const t2dTenants = ["ossian", "lilly", "novo", "uef"];

var PRIMEControllers = angular.module('PRIMEControllers', []).run(function($rootScope, $location) {
	$rootScope.plurals = {
		"cohorts" : { 0: "Cohorts", one: "Cohort", other: "Cohorts" },
		"treatments" : { 0: "Treatments", one: "Treatment", other: "Treatments" },
		"costs" : { 0: "Costs", one: "Cost", other: "Costs" },
		"utilities" : { 0: "Utilities", one: "Utility", other: "Utilities" },
		"countries" : { 0: "Countries", one: "Country", other: "Countries" },
		"sensitivityanalyses" : { 0: "Sensitivity Analyses", one: "Sensitivity Analysis", other: "Sensitivity Analyses" }
	}
	$rootScope.panes = [
		{ "name": { 0: "Home", one: "Home", other: "Home" }, "simulationDataSource":false,"id":"home", "description": "PRIME Model homepage", "partial":"home.html" },
		{ "name": $rootScope.plurals["cohorts"], "simulationDataSource":true, "id":"cohorts", "code":"cohortIDs", "description": "Create, view, edit or delete definitions of patient cohorts", "partial":"cohorts.html", "controller":"Cohorts", "sameInBothSimulationArms":true },
		{ "name": $rootScope.plurals["treatments"], "simulationDataSource":true,"id":"treatments", "code":"treatmentIDs", "description": "Create, view, edit or delete treatments", "partial":"treatments.html", "controller":"Treatments", "sameInBothSimulationArms":false },
		{ "name": $rootScope.plurals["costs"], "simulationDataSource":true,"id":"costs", "code":"costIDs", "description": "Create, view, edit or delete groups of complication costs", "partial":"costs.html", "controller":"Costs", "sameInBothSimulationArms":true },
		{ "name": $rootScope.plurals["utilities"], "simulationDataSource":true, "id":"utilities", "code":"utilityIDs", "description": "Create, view, edit or delete sets of quality of life utilities", "partial":"utilities.html", "controller":"Utilities", "sameInBothSimulationArms":true },
		{ "name": $rootScope.plurals["countries"], "simulationDataSource":true, "id":"countries", "code":"countryIDs", "description": "Create, view, edit or delete sets of country-specific data", "partial":"countries.html", "controller":"Countries", "sameInBothSimulationArms":true },
		/*{ "name": $rootScope.plurals["sensitivityanalyses"], "simulationDataSource":true, "id":"sensitivity-analyses", "description": "Create, view, edit or delete sets of one-way sensitivity analyses", "partial":"owsas.html", "controller":"SensitivityAnalyses", "sameInBothSimulationArms":true },*/
		{ "name": { 0: "Simulations", one: "Simulation", other: "Simulations" }, "simulationDataSource":false, "id":"simulations", "description": "Run, view or delete simulations", "partial":"simulations.html" }
	];

	$rootScope.syncPane = function (simulation, sameInBothSimulationArms, elementId, fullElements) {
		if (sameInBothSimulationArms && simulation.elements[elementId].length > 1) {
			simulation.elements[elementId] = simulation.elements[elementId].toSpliced(-1, 1);
			simulation.fullElements[fullElements] = simulation.fullElements[fullElements].toSpliced(-1, 1);
		}
	}

	$rootScope.user = {};
	
	$rootScope.models = [
		{ id:1, name: "Type 1"},
		{ id:2, name: "Type 2"}
	];
	
	$rootScope.model = {};
	$rootScope.model.current = $location.path().lastIndexOf("t2d") !== -1 ? 2 : ($location.path().lastIndexOf("ukpdsom2") !== -1 ? 3 : 1);
	$rootScope.model.pathComponent = function() {
		switch ($rootScope.model.current) {
		case 1:
			return "";
		case 2:
			return "t2d/"
		case 3:
			return "ukpdsom2/"
		}
	}
	
	$rootScope.$watch("model.current", function (newValue, oldValue, scope) {
		if ($location && newValue != oldValue) {
			$location.path("/" + $rootScope.model.pathComponent() + $location.path().substring($location.path().lastIndexOf("/") + 1));
		}
	});
	
	$rootScope.hypoOptions = [
		{ id:1, name: "All severe, all non-severe hypoglycemia" },
		{ id:2, name: "All severe hypoglycemia, nocturnal and daytime non-severe hypoglycemia" }
	];

	$rootScope.riskFactorProgressionTypes = [
		{ type: "CONSTANT", name: "Constant" },
		{ type: "MODELED_PROGRESSION", name: "Modeled progression" },
		{ type: "ANNUAL_CHANGE", name: "Annual change" },
	];

	$rootScope.qolCombinationOptions = [
		{ id:0, name: "Additive" },
		{ id:1, name: "Multiplicative" }
	];
	
	$rootScope.qolCombinationOptionsT2D = [
		{ id:"ADDITIVE", name: "Additive" },
		{ id:"ADDITIVE_ARA_AND_BRAZIER", name: "Additive (Ara and Brazier)" },
		{ id:"ADDITIVE_NORWEGIAN", name: "Additive (NoMA)" },
		{ id:"MULTIPLICATIVE", name: "Multiplicative" },
		{ id:"MULTIPLICATIVE_ARA_AND_BRAZIER", name: "Multiplicative (Ara and Brazier)" },
		{ id:"MULTIPLICATIVE_NORWEGIAN", name: "Multiplicative (NoMA)" },
		{ id:"SHAO", name: "Shao et al. 2019" }
	];
	
	$rootScope.qolCombinationOptionsUKPDSOM2 = [
		{ id:"ADDITIVE", name: "Additive" },
		{ id:"SHAO", name: "Shao et al. 2019" }
	];

	$rootScope.insulinDurabilityOptions = [
		{ id: "FIXED", name: "Fixed" },
		{ id: "ANNUAL_PROBABILITY", name: "Annual probability"}
	];

	$rootScope.cVDModelAveragingOptions = [
		{ id:1, name: "Cederholm" },
		{ id:2, name: "Klein" },
		{ id:3, name: "Lung" },
		{ id:4, name: "Eurodiab" },
		{ id:5, name: "Framingham" },
		{ id:6, name: "FinnDiane" }
	];
	
	$rootScope.cVDT2DModelAveragingOptions = [
		{ id:1, name: "UKPDS OM2" },
		{ id:2, name: "BRAVO" },
		{ id:3, name: "JJ Risk Engine" }
	];
	
	$rootScope.apiConfig = [
		{ "DBURL": "https://prime-diabetes-model.com:27017/" }
	]

	$rootScope.toggleSidebar = function () {
		$rootScope.$broadcast("toggleSidebar");
	};
  
})

PRIMEControllers.constant('FeatureFlags', window.APP_FLAGS || {
	obesityMode: false,
	vertexMode: false
});

PRIMEControllers.controller("AuthenticationTestController", ["$rootScope", "$window", function ($rootScope, $window) {
	angular.element(document).ready(function () {
		$.ajax({
			url:"/api/authenticated",
			timeout:5000,
			dataType:"json",
			success:function(data, textStatus, jqXHR) {
				$rootScope.$apply(function () {
					$rootScope.user = data.user;
					if (data.user.company.indexOf("Ossian") !== -1) {
						// Activate advanced mode universally
						$rootScope.advanced = true;

						// Enable the model switch
						$rootScope.modelSwitch = true;

						// Add the UKPDS OM2 as a model option
						$rootScope.models.push({ id:3, name: "UKPDS OM2"});
					} else {
						// Disable advanced mode for all non-Ossian users
						$rootScope.advanced = false;


						// Enable the model switch for Lilly, Novo, Bristol University, and PRIMA
						if (
							data.user.company.indexOf("NICE PRIMA") !== -1 ||
							data.user.company.indexOf("Bristol University") !== -1 ||
							data.user.company.indexOf("St James") !== -1
						|| t2dTenants.includes(data.user.tenantId)) {
							$rootScope.modelSwitch = true;
						} else {
							$rootScope.modelSwitch = false;
						}
					}
				});
			},
			error:function(jqXHR, textStatus, errorThrown) {
				// Redirect in case global error handler (responseObserver service) is not yet registered
				$window.location = '/login.html?redirectAfterLogin=' + encodeURIComponent($window.location);
			}
		});
	});
}]);

PRIMEControllers.controller("Page", ["$scope", "$rootScope", function ($scope, $rootScope) {
	$scope.sidebar = false;
	
	var unregisterSidebarToggle = $scope.$on("toggleSidebar", function(ngEvent) {
		ngEvent.currentScope.sidebar = !ngEvent.currentScope.sidebar;
	});
	
	var unregisterSidebarHide = $scope.$on("hideSidebar", function(ngEvent) {
		ngEvent.currentScope.sidebar = false;
	});
	
	$scope.$on("$destroy", unregisterSidebarToggle);
	$scope.$on("$destroy", unregisterSidebarHide);
	
}]);

PRIMEControllers.controller("AccountPreferences", ["$scope", "$modalInstance", function($scope, $modalInstance) {
	$scope.strings = {
		"title":"Account preferences",
		"createButton":"Save changes",
		"cancelButton":"Cancel"
	}
	
	$scope.cancel = function () { $modalInstance.dismiss('cancel'); };
}]);

PRIMEControllers.controller("Header", ["$scope", "$window", "$rootScope", "$modal", "$location", "$http", function ($scope, $window, $rootScope, $modal, $location, $http) {
	$scope.strings = {
		"modelName":"The PRIME Diabetes Model",
		"users": "Manage users",
		"share":"Share documents",
		"help":"User Guide",
		"preferences":"Preferences",
		"logout":"Logout"
	}

	$scope.users = function () {
		$location.path('/admin/users');
	}

	$scope.share = function() {
		$location.path('/admin/share/documents');
	};
	
	$scope.logout = function() {
		$http.get("/api/logout")
			.finally(function () {
				$window.location = "/login";
			}
		);
	};
	
	$scope.help = function() {
		$window.open('/img/PRIME-T2D-Model-Technical-Report-22-08-03.pdf', '_blank');
	}
	
	$scope.accountPreferences = function() {
		var modalInstance = $modal.open({
			templateUrl: "partials/account.html",
			controller: "AccountPreferences",
			size: 'lg',
			resolve: { }
		});
		
		modalInstance.result.then(function (user) {
			user.$save({}, function(data) {
				// Success
			}, function(err) {
				// Error
			});
		}, function () {
			console.log("Account preferences modal dismissed at: " + new Date());
		});
	}
}]);

PRIMEControllers.controller("Footer", function ($scope) {
	$scope.strings = {
		"copyright":"© 2015-2026 Ossian Health Economics and Communications GmbH",
		"statusMessage":""
	}
});

PRIMEControllers.controller("Login", [
	"$rootScope","$scope", "$window", "$location", "$http", "$httpParamSerializerJQLike",
	function($rootScope, $scope, $window, $location, $http, $httpParamSerializerJQLike) {

		$scope.getQueryStringValue = function(key) {
			return decodeURIComponent(
					$window.location.search.replace(
							new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"),
							"$1"
					)
			);
		};

		$scope.redirectAfterLogin = $scope.getQueryStringValue("redirectAfterLogin");
		$scope.logoPath = "";
		$scope.clientName = "";
		if ($location.host().includes("novo")) {
			$scope.logoPath = "img/novo.png";
			$scope.clientName = "Novo Nordisk";
		}

		$scope.creds = { username: "", password: "" };
		$scope.error = null;

		$scope.login = function () {
			$scope.error = null;

			const body = $httpParamSerializerJQLike({
				username: $scope.creds.username,
				password: $scope.creds.password
			});

			$http({
				method: "POST",
				url: "/api/login",
				data: body,
				headers: { "Content-Type": "application/x-www-form-urlencoded" }
			})
			.then(function (res) {
				// Node returns 200 JSON: { message: "...", user: {...} }
				// Session cookie is set via the same-origin proxy.
        const modelPrefix = t2dTenants.includes(res.data.user.tenantId) ? "t2d/" : "";
				$window.location = "/#!/" + modelPrefix + "home";
			})
			.catch(function (err) {
				$scope.error = (err.data && err.data.message) || "Login failed";
			});
		};
	}
]);

PRIMEControllers.controller("Sidebar", function ($scope) {

});

PRIMEControllers.controller("TabPaneController", function($scope) {
	
	$scope.configureAsTabPane = function() {	
		if ($scope.isTabbedPane) {
			$scope.showCheckboxes = false;
			$scope.showDragHandles = true;
			$scope.linkModal = true;
		} else {
			$scope.showCheckboxes = true;
			$scope.showDragHandles = false;
			$scope.linkModal = false;
		}
	}
	
})

PRIMEControllers.controller("Home", function ($scope) {
	$scope.strings = {
		"title":"Home",
		"welcome":"Welcome to the PRIME Diabetes Model for Type 1 Diabetes Mellitus in Adults"
	}
});






// ===============================================
// Cohorts
// ===============================================
PRIMEControllers.controller("Cohorts", ["$scope", "$routeParams", "$location", "$modal", "$controller", "Cohort", function ($scope, $routeParams, $location, $modal, $controller, Cohort, NewCohort, EditCohort) {

	$controller("TabPaneController", {$scope: $scope});
	
	$scope.configureAsTabPane();
	
	$scope.predicate = 'creationDate';
	$scope.reverse = true;
	
	$scope.newCohort = function(size) {
		var modalInstance = $modal.open({
			templateUrl: "partials/cohort-new.html?v=1.5.3",
			controller: "NewCohort",
			size: size,
			resolve: {
				cohorts: function () {
					return $scope.cohorts;
				}
			},
		});

		modalInstance.result.then(function (newCohort) {
			new Cohort(newCohort).$save({}, function(data) {
				$scope.cohorts.push(data);
			}, function(err) {
				console.log("A database error occurred.");
			});
		}, function () {
			console.log("Create cohort modal dismissed at: " + new Date());
		});
	}

	$scope.editCohortModal = function(size, id) {
		var modalInstance = $modal.open({
			templateUrl: "partials/cohort-new.html?v=1.5.3",
			controller: "EditCohortModal",
			size: size,
			resolve: {
				cohorts: function () { return $scope.cohorts; },
				cohortId: function() { return id; },
        viewOnly: function () { return false; }
			}
		});

		modalInstance.result.then(function (editedCohort) {
			editedCohort.$update({}, function(data) {
				$scope.cohorts.filter(function(cohort, index, cohorts) {
					if (cohort._id === data._id) {
						cohorts[index] = data;
					}
				});
			}, function(err) {
				console.log("A database error occurred.");
			});
		}, function (reason) {
			console.log("Edit cohort modal dismissed at: " + new Date());
		});
		
	}
	
	
	
	$scope.strings = {
		"title":"Type 1 Cohorts",
		"new":"New",
		"delete":"Delete",
		"clone":"Duplicate",
		"baselineCharacteristics":"Baseline characteristics",
		"search":"Search cohorts"
	}
	
	$scope.cohorts = Cohort.query();
	
	$scope.selectedItems = function() {
		var count = 0;
		angular.forEach($scope.cohorts, function(value){
			if (value.selected) count++;
		});
		return count;
	}

  $scope.hasOwnership = function() {
    let owner = true;
    angular.forEach($scope.cohorts, function(value){
      if (value.selected && !value.owner) owner = false;
    });

    return owner;
  }
	
	$scope.cloneSelected = function(options) {
		$scope.cohorts.forEach(function(cohort, idx) {
			if (cohort.selected) {
				var duplicateCohort = angular.copy(cohort);
				delete cohort.selected;

				delete duplicateCohort._id;
				delete duplicateCohort.selected;
				duplicateCohort.sharedWith = [];
				duplicateCohort.creationDate = new Date().getTime();
				duplicateCohort.name = duplicateCohort.name + " copy";
				duplicateCohort.clonedFrom = cohort._id;
				
				duplicateCohort.$save({}, function(data) {
					$scope.cohorts.push(duplicateCohort);
					if (options.modal) {
						$scope.editCohortModal('lg', duplicateCohort._id);
					} else {
						$location.path('/cohort/' + duplicateCohort._id);
					}
				})
			}
		})
	}
	
	$scope.deleteSelected = function() {
		$scope.cohorts.forEach(function(cohort, idx) {
			if (cohort.selected) {
				cohort.$delete({}, function(data) {
					$scope.cohorts = $scope.cohorts.filter(function(cohort) {
						return cohort._id !== undefined;
					});
				})
			}
		})
	};
	
}]);

PRIMEControllers.controller("EditCohort", ["$scope", "$routeParams", "$location", "Cohort",  function($scope, $routeParams, $location, Cohort) {
	$scope.strings = {
		"title":"Cohort",
		"createButton":"Save changes",
		"cancelButton":"Cancel"
	}
	$scope.cohort = Cohort.get({cohortId:$routeParams.id});
	$scope.backVisible = true;
  $scope.cohort.$promise.then(function(cohort) {
    $scope.readOnly = !cohort.owner;
  });

	$scope.validateRetinopathyStates = validateRetinopathyStates($scope);
	$scope.validateRenalStates = validateRenalStates($scope);

	$scope.ok = function () {
		$scope.cohort.$update({}, function(data) {
			$location.path('/cohorts');
		})
	};

	$scope.cancel = function () {
		$location.path('/cohorts');
	};
}]);

PRIMEControllers.controller("EditCohortModal", ["$scope", "$modalInstance", "$routeParams", "$location", "Cohort", "cohortId", "cohorts", "viewOnly", function($scope, $modalInstance, $routeParams, $location, Cohort, cohortId, cohorts, viewOnly) {
	$scope.strings = {
		"title":"Cohort",
		"createButton":"Save changes",
		"cancelButton":"Cancel"
	}
	
	if (cohorts !== null) {
		$scope.cohort = angular.copy(cohorts.filter(function(cohort){
			return cohort._id === cohortId;
		})[0]);
    $scope.readOnly = viewOnly || !$scope.cohort.owner;
	} else {
		$scope.cohort = Cohort.get({cohortId:cohortId});
    $scope.cohort.$promise.then(function(cohort) {
      $scope.readOnly = viewOnly || !cohort.owner;
			$scope.cohort = cohort;
    })
			.catch(function () {
				$scope.readOnly = true;
			});
	}
	$scope.validateRetinopathyStates = validateRetinopathyStates($scope);
	$scope.validateRenalStates = validateRenalStates($scope);

	$scope.backVisible = false;
	
	$scope.ok = function () { $modalInstance.close($scope.cohort); };
	$scope.cancel = function () { $modalInstance.dismiss('cancel'); };

}]);

PRIMEControllers.controller("NewCohort", ["$scope", "$modalInstance", "Cohort", "DefaultCohort", "DefaultCohorts", function ($scope, $modalInstance, Cohort, DefaultCohort, DefaultCohorts) {
	$scope.strings = {
		"title":"New cohort",
		"createButton":"Create new cohort",
		"cancelButton":"Cancel"
	}
	$scope.copyCohort = function (cohort) {
		const duplicateCohort = angular.copy(cohort);

		delete duplicateCohort.creator;
		delete duplicateCohort._id;
		duplicateCohort.sharedWith = [];
		duplicateCohort.creationDate = new Date().getTime();
		duplicateCohort.name = "New cohort";
		duplicateCohort.clonedFrom = cohort._id;

		return duplicateCohort;
	}

	$scope.create = true;
	$scope.cohort = $scope.copyCohort(DefaultCohort);
	$scope.cohort.creationDate = new Date().getTime();
	$scope.backVisible = false;

	$scope.validateRetinopathyStates = validateRetinopathyStates($scope);
	$scope.validateRenalStates = validateRenalStates($scope);

	$scope.changeDefault = function() {
		const defaultCohort = $scope.defaultCohorts.filter(function(cohort) {
			return cohort._id === $scope.defaultCohort;
		})[0];
		$scope.cohort = $scope.copyCohort(defaultCohort);
	}

	$scope.defaultCohorts = DefaultCohorts;
	(function() {
		const defaultCohort = $scope.defaultCohorts.filter(function(cohort) {
			return cohort.name === "DCCT intensive";
		})[0];
		$scope.cohort = $scope.copyCohort(defaultCohort);
		$scope.defaultCohort = defaultCohort._id;
	})();
	
	
	$scope.ok = function () { delete $scope.cohort._id; $modalInstance.close($scope.cohort); };
	$scope.cancel = function () { $modalInstance.dismiss('cancel'); };
}]);








// ===============================================
// Treatments
// ===============================================
PRIMEControllers.controller("Treatments", ["$scope", "$location", "$modal", "$controller", "Treatment", function ($scope, $location, $modal, $controller, Treatment) {

	$controller("TabPaneController", {$scope: $scope});
	
	$scope.configureAsTabPane();
	
	$scope.predicate = 'creationDate';
	$scope.reverse = true;
	
	$scope.newTreatment = function(size) {
		var modalInstance = $modal.open({
			templateUrl: "partials/treatment-new.html?v=1.5.3",
			controller: "NewTreatment",
			size: size,
			resolve: {
				treatments: function () {
					return $scope.treatments;
				}
			}
		});

		modalInstance.result.then(function (newTreatment) {
			new Treatment(newTreatment).$save({}, function(data) {
				$scope.treatments.push(data);
				console.log("New treatment created: ", data);
			}, function(err) {
				console.log("A database error occurred.");
			});
		}, function () {
			console.log("Create treatment modal dismissed at: " + new Date());
		});
	}
	
	$scope.editTreatmentModal = function(size, id) {
		var modalInstance = $modal.open({
			templateUrl: "partials/treatment-new.html?v=1.5.3",
			controller: "EditTreatmentModal",
			size: size,
			resolve: {
				treatments: function () { return $scope.treatments; },
				treatmentId: function() { return id; },
        viewOnly: function () { return false; }
			}
		});

		modalInstance.result.then(function (editedTreatment) {
			editedTreatment.$update({}, function(data) {
				$scope.treatments.filter(function(treatment, index, treatments) {
					if (treatment._id === data._id) {
						treatments[index] = data;
					}
				});
			}, function(err) {
				console.log("A database error occurred.");
			});
		}, function (reason) {
			console.log("Edit treatment modal dismissed at: " + new Date());
		});
	}
	
	$scope.strings = {
		"title":"Type 1 Treatments",
		"search":"Search treatments",
		"new":"New",
		"delete":"Delete",
		"clone":"Duplicate"
	}

	$scope.treatments = Treatment.query();
	
	$scope.selectedItems = function() {
		var count = 0;
		angular.forEach($scope.treatments, function(value){
			if (value.selected) count++;
		});
		return count;
	}

  $scope.hasOwnership = function() {
    let owner = true;
    angular.forEach($scope.treatments, function(value){
      if (value.selected && !value.owner) owner = false;
    });

    return owner;
  }
	
	$scope.cloneSelected = function(options) {
		$scope.treatments.forEach(function(treatment, idx) {
			if (treatment.selected) {
				var duplicateTreatment = angular.copy(treatment);
				delete treatment.selected;

				delete duplicateTreatment._id;
				delete duplicateTreatment.selected;
				duplicateTreatment.sharedWith = [];
				duplicateTreatment.creationDate = new Date().getTime();
				duplicateTreatment.name = duplicateTreatment.name + " copy";
				duplicateTreatment.clonedFrom = treatment._id;
				ensureAnnualProbabilitiesArray(duplicateTreatment);

				duplicateTreatment.$save({}, function(data) {
					$scope.treatments.push(duplicateTreatment);
					if (options.modal) {
						$scope.editTreatmentModal('lg', duplicateTreatment._id);
					} else {
						$location.path('/treatment/' + duplicateTreatment._id);
					}
				})
			}
		})
	}
	
	$scope.deleteSelected = function() {
		$scope.treatments.forEach(function(treatment, idx) {
			if (treatment.selected) {
				treatment.$delete({}, function(data) {
					$scope.treatments = $scope.treatments.filter(function(treatment) {
						return treatment._id !== undefined;
					});
				})
			}
		})
	};
	
}]);

function normalizeSwitchCondition(sc) {
    if (!sc) return;

    switch (sc.switchType) {
        case "DURATION":
            sc.annualProbabilityOfSwitch = undefined;
            sc.eventSwitchProperty = undefined;
            sc.treatmentEffectSwitchProperty = undefined;
            sc.switchThreshold = undefined;
            sc.switchAboveThreshold = undefined;
            break;

        case "PROBABILITY":
            sc.maximumTreatmentDuration = undefined;
            sc.eventSwitchProperty = undefined;
            sc.treatmentEffectSwitchProperty = undefined;
            sc.switchThreshold = undefined;
            sc.switchAboveThreshold = undefined;
            break;

        case "EVENT":
            sc.maximumTreatmentDuration = undefined;
            sc.annualProbabilityOfSwitch = undefined;
            sc.treatmentEffectSwitchProperty = undefined;
            sc.switchThreshold = undefined;
            sc.switchAboveThreshold = undefined;
            // value already in sc.eventSwitchProperty via the HTML tweak
            break;

        case "THRESHOLD":
            sc.maximumTreatmentDuration = undefined;
            sc.annualProbabilityOfSwitch = undefined;
            sc.eventSwitchProperty = undefined;
            // keep: sc.treatmentEffectSwitchProperty, sc.switchThreshold, sc.switchAboveThreshold
            break;

        default:
            // if nothing selected, leave as-is (or pick a default)
            break;
    }

    // The API/Java don’t use this—UI-only
    delete sc.switchType;

    // Recurse down the chain
    if (sc.subsequentTreatment && sc.subsequentTreatment.switchCondition) {
        normalizeSwitchCondition(sc.subsequentTreatment.switchCondition);
    }
}

function getValidateFirstYearRatios($scope) {
	return function () {
		if (!$scope.calc) {
			$scope.calc = { sumOfRatios: 100, firstYearTotal100: true };
		}

		const gft = $scope.treatment && $scope.treatment.graftFunctionTreatment && $scope.treatment.graftFunctionTreatment.insulinStatusInFirstYear
			? $scope.treatment.graftFunctionTreatment.insulinStatusInFirstYear
			: {};

		let sumOfRatios = (gft.insulinIndependentRatio || 0) +
			(gft.pgfRatio || 0) +
			(gft.ngfRatio || 0);

		$scope.calc.sumOfRatios = sumOfRatios;
		$scope.calc.firstYearTotal100 = (sumOfRatios > 99.999 && sumOfRatios < 100.001);

		if ($scope.newTreatment && $scope.newTreatment.insulinIndependentRatio) {
			const field = $scope.newTreatment.insulinIndependentRatio;
			if (sumOfRatios !== 100) {
				field.$setValidity("sumOfRatios", false);
			} else {
				field.$setValidity("sumOfRatios", true);
			}
		}
	};
}

function validateRetinopathyStates($scope) {
	return function () {
		const field = $scope.newCohort.retinoStateProportionMap;
		let sumOfProportions = $scope.cohort.retinopathyAtBaseline.stateProportionMap.NO;
		sumOfProportions += $scope.cohort.retinopathyAtBaseline.stateProportionMap.MILD_NPDR;
		sumOfProportions += $scope.cohort.retinopathyAtBaseline.stateProportionMap.MODERATE_NPDR;
		sumOfProportions += $scope.cohort.retinopathyAtBaseline.stateProportionMap.SEVERE_NPDR;
		sumOfProportions += $scope.cohort.retinopathyAtBaseline.stateProportionMap.PDR;
    sumOfProportions += $scope.cohort.retinopathyAtBaseline.stateProportionMap.SVL;

		if (sumOfProportions !== 100) {
			field.$setValidity("sumOfProportions", false);
		} else {
			field.$setValidity("sumOfProportions", true);
		}
	}
}

function validateRenalStates($scope) {
	return function () {
		const field = $scope.newCohort.renalStateProportionMap;
		let sumOfProportions = $scope.cohort.renalStateDistributionAtBaseline.stateProportionMap.NORMAL;
		sumOfProportions += cohort.renalStateDistributionAtBaseline.stateProportionMap.MICROALBUMINURIA;
		sumOfProportions += cohort.renalStateDistributionAtBaseline.stateProportionMap.OVERT;
		sumOfProportions += cohort.renalStateDistributionAtBaseline.stateProportionMap.ESRD;

		if (sumOfProportions !== 100) {
			field.$setValidity("sumOfProportions", false);
		}
		else {
			field.$setValidity("sumOfProportions", true);
		}
	}
}

function ensureArray(apt) {
	const ap = apt.annualProbabilities;

	if (Array.isArray(ap)) return;

	// convert {"0":..,"1":..} -> [..] if already "map-shaped"
	if (ap && typeof ap === "object") {
		apt.annualProbabilities = [0, 1, 2, 3, 4].map(i => Number(ap[i] ?? ap[String(i)] ?? 0));
		return;
	}

	// missing/undefined -> create default array
	apt.annualProbabilities = [0, 0, 0, 0, 0];
}

function ensureAnnualProbabilitiesArray(t) {
	// be defensive with old docs
	t.therapy = t.therapy || {};
	t.therapy.durabilityOfInsulinIndependence = t.therapy.durabilityOfInsulinIndependence || {};
	t.therapy.durabilityOfPartialgraftStatus = t.therapy.durabilityOfPartialgraftStatus || {};
	t.therapy.reInfusionParameters = t.therapy.reInfusionParameters || {};

	const dii = t.therapy.durabilityOfInsulinIndependence;
	dii.annualProbabilityOfTransition = dii.annualProbabilityOfTransition || {};
	ensureArray(dii.annualProbabilityOfTransition);

	const dpgf = t.therapy.durabilityOfPartialgraftStatus;
	dpgf.annualProbabilityOfTransition = dpgf.annualProbabilityOfTransition || {};
	ensureArray(dpgf.annualProbabilityOfTransition);

	const rip = t.therapy.reInfusionParameters;
	rip.annualProbabilityOfReInfusion = rip.annualProbabilityOfTransition || {};
	ensureArray(rip.annualProbabilityOfReInfusion);
}

function getHasWaitingPeriod($scope) {
	return function() {
		return !!$scope.treatment.graftFunctionTreatment && $scope.treatment.graftFunctionTreatment.yearsToTransplant > 0;
	};
}

PRIMEControllers.controller("NewTreatment", ["$scope", "$rootScope", "$modalInstance", "Treatment", "DefaultTreatment", "DefaultTreatmentSwitch", "SwitchEvents", "SwitchRiskFactors", "FeatureFlags", function ($scope, $rootScope, $modalInstance, Treatment, DefaultTreatment, DefaultTreatmentSwitch, SwitchEvents, SwitchRiskFactors, FeatureFlags) {
	$scope.strings = {
		"title":"New treatment",
		"createButton":"Create new treatment",
		"cancelButton":"Cancel"
	};

	$scope.vertexMode = FeatureFlags.vertexMode;
	$scope.findDeepestTreatment = function(treatment) {
		if (treatment.switchCondition !== null && treatment.switchCondition !== undefined) {
			return $scope.findDeepestTreatment(treatment.switchCondition.subsequentTreatment);
		} else {
			return treatment;
		}
	}
	$scope.hypoOptions = $rootScope.hypoOptions;
	$scope.riskFactorProgressionTypes = $rootScope.riskFactorProgressionTypes;
	$scope.durabilityOptions = $rootScope.insulinDurabilityOptions;

	$scope.switchEvents = SwitchEvents;
	$scope.switchRiskFactors = SwitchRiskFactors;
	
	$scope.treatment = angular.copy(DefaultTreatment);
	$scope.treatment.creationDate = new Date().getTime();
	$scope.backVisible = false;

	$scope.calc = { sumOfRatios: 100, firstYearTotal100: true };

	$scope.validateFirstYearRatios = getValidateFirstYearRatios($scope);
	$scope.validateFirstYearRatios();

	$scope.validateFirstYearRatios = getValidateFirstYearRatios($scope);
	getValidateFirstYearRatios($scope)();

	$scope.hasWaitingPeriod = getHasWaitingPeriod($scope);
	$scope.hasWaitingPeriod();

	$scope.removeSwitch = function(treatment) {
			if (treatment && treatment.switchCondition) {
					treatment.switchCondition = null;
			}
	}
	
	$scope.navigateToTreatment = function() {
		$(".switchable-container").scrollTo($(".subsequent-treatment").last(), 500);
	}
	
	$scope.addSwitch = function() {
		var deepestTreatment = $scope.findDeepestTreatment($scope.treatment);
		deepestTreatment.switchCondition = angular.copy(DefaultTreatmentSwitch);
        deepestTreatment.switchCondition.subsequentTreatment.name = (deepestTreatment.name || 'Treatment') + " subsequent";

        if (!deepestTreatment.switchCondition.switchType) {
            deepestTreatment.switchCondition.switchType = "DURATION";
        }
	
		$scope.$$postDigest(function() {
			$(".switchable-container").scrollTo($(".switchable-container .condition-in-switchable-container").last(), 500, {offset: {left:0, top:0}});
		});
	};

	$scope.ok = function () {
        if ($scope.treatment && $scope.treatment.switchCondition) {
            normalizeSwitchCondition($scope.treatment.switchCondition);
        }
        $modalInstance.close($scope.treatment);
	};

	$scope.cancel = function () {
		$modalInstance.dismiss('cancel');
	};
}]);

PRIMEControllers.controller("EditTreatment", ["$scope", "$rootScope", "$routeParams", "$location", "Treatment", "DefaultTreatmentSwitch", "SwitchEvents", "SwitchRiskFactors", "FeatureFlags", function($scope, $rootScope, $routeParams, $location, Treatment, DefaultTreatmentSwitch, SwitchEvents, SwitchRiskFactors, FeatureFlags) {
	$scope.strings = {
		"title":"Treatment",
		"createButton":"Save changes",
		"cancelButton":"Cancel"
	};
	$scope.vertexMode = FeatureFlags.vertexMode;
	$scope.findDeepestTreatment = function(treatment) {
		if (treatment.switchCondition !== null && treatment.switchCondition !== undefined) {
			return $scope.findDeepestTreatment(treatment.switchCondition.subsequentTreatment);
		} else {
			return treatment;
		}
	}
	$scope.hypoOptions = $rootScope.hypoOptions;
	$scope.riskFactorProgressionTypes = $rootScope.riskFactorProgressionTypes;
	$scope.durabilityOptions = $rootScope.insulinDurabilityOptions;
	$scope.switchEvents = SwitchEvents;
	$scope.switchRiskFactors = SwitchRiskFactors;

    // --- infer current mode from persisted fields (for radio preselect) ---
    function inferSwitchType(sc) {
        if (!sc) return undefined;
        if (sc.maximumTreatmentDuration != null) return "DURATION";
        if (sc.annualProbabilityOfSwitch != null) return "PROBABILITY";
        if (sc.eventSwitchProperty != null) return "EVENT";
        if (sc.treatmentEffectSwitchProperty != null || sc.switchThreshold != null || sc.switchAboveThreshold != null) return "THRESHOLD";
        return "DURATION";
    }

    function setSwitchTypesForUI(treatment) {
        var node = treatment;
        while (node && node.switchCondition) {
            var sc = node.switchCondition;
            sc.switchType = inferSwitchType(sc);
            node = sc.subsequentTreatment;
        }
    }

    $scope.treatment = Treatment.get({treatmentId:$routeParams.id}, function (t) {
        setSwitchTypesForUI(t);
    });

	$scope.backVisible = true;
  $scope.treatment.$promise.then(function(treatment) {
    $scope.readOnly = !treatment.owner;
  });

    $scope.removeSwitch = function(treatment) {
        if (treatment && treatment.switchCondition) {
            treatment.switchCondition = null;
        }
    }
	
	$scope.navigateToTreatment = function() {
		$(".switchable-container").scrollTo($(".subsequent-treatment").last(), 500);
	}
	
	$scope.addSwitch = function() {
		var deepestTreatment = $scope.findDeepestTreatment($scope.treatment);
		deepestTreatment.switchCondition = angular.copy(DefaultTreatmentSwitch);
        deepestTreatment.switchCondition.subsequentTreatment.name = (deepestTreatment.name || 'Treatment') + " subsequent";

        if (!deepestTreatment.switchCondition.switchType) {
            deepestTreatment.switchCondition.switchType = "DURATION";
        }
	
		$scope.$$postDigest(function() {
			$(".switchable-container").scrollTo($(".switchable-container .condition-in-switchable-container").last(), 500, {offset: {left:0, top:0}});
		});
	};
	
	$scope.ok = function () {
        // prune UI-only fields & enforce single mode before update
        if ($scope.treatment && $scope.treatment.switchCondition) {
            normalizeSwitchCondition($scope.treatment.switchCondition);
        }

        $scope.treatment.$update({}, function () {
            $location.path('/treatments');
        });
	};

	$scope.cancel = function () {
		$location.path('/treatments');
	};

	$scope.calc = { sumOfRatios: 100, firstYearTotal100: true };
	$scope.validateFirstYearRatios = getValidateFirstYearRatios($scope);
	$scope.treatment.$promise.then(function() {
		$scope.validateFirstYearRatios();
	});

	$scope.hasWaitingPeriod = getHasWaitingPeriod($scope);
	$scope.hasWaitingPeriod();
}])

PRIMEControllers.controller("EditTreatmentModal", ["$scope", "$rootScope", "$modalInstance", "$routeParams", "$location", "Treatment", "DefaultTreatmentSwitch", "SwitchEvents", "SwitchRiskFactors", "treatmentId", "treatments", "viewOnly", "FeatureFlags", function($scope, $rootScope, $modalInstance, $routeParams, $location, Treatment, DefaultTreatmentSwitch, SwitchEvents, SwitchRiskFactors, treatmentId, treatments, viewOnly, FeatureFlags) {
	$scope.strings = {
		"title":"Treatment",
		"createButton":"Save changes",
		"cancelButton":"Cancel"
	};
	$scope.vertexMode = FeatureFlags.vertexMode;
	$scope.findDeepestTreatment = function(treatment) {
		if (treatment.switchCondition !== null && treatment.switchCondition !== undefined) {
			return $scope.findDeepestTreatment(treatment.switchCondition.subsequentTreatment);
		} else {
			return treatment;
		}
	}
	$scope.hypoOptions = $rootScope.hypoOptions;
	$scope.riskFactorProgressionTypes = $rootScope.riskFactorProgressionTypes;
	$scope.durabilityOptions = $rootScope.insulinDurabilityOptions;

	$scope.switchEvents = SwitchEvents;
	$scope.switchRiskFactors = SwitchRiskFactors;
	
	if (treatments !== null) {
		$scope.treatment = angular.copy(treatments.filter(function(treatment){
			return treatment._id === treatmentId;
		})[0]);
    $scope.readOnly = viewOnly || !$scope.treatment.owner;
		ensureAnnualProbabilitiesArray($scope.treatment);
	} else {
		$scope.treatment = Treatment.get({treatmentId:treatmentId});
    $scope.treatment.$promise.then(function(treatment) {
      $scope.readOnly = viewOnly || !treatment.owner;
			ensureAnnualProbabilitiesArray(treatment);
    })
			.catch(function () {
				$scope.readOnly = true;
			});
	}
	
	$scope.navigateToTreatment = function() {
		$(".switchable-container").scrollTo($(".subsequent-treatment").last(), 500);
	}
	
	$scope.addSwitch = function() {
		var deepestTreatment = $scope.findDeepestTreatment($scope.treatment);
		deepestTreatment.switchCondition = angular.copy(DefaultTreatmentSwitch);
		deepestTreatment.switchCondition.subsequentTreatment.name = (deepestTreatment.name || 'Treatment') + " subsequent";

		$scope.$$postDigest(function() {
			$(".switchable-container").scrollTo($(".switchable-container .condition-in-switchable-container").last(), 500, {offset: {left:0, top:0}});
		});
	};
	
	$scope.backVisible = false;

    $scope.removeSwitch = function(treatment) {
        if (treatment && treatment.switchCondition) {
            treatment.switchCondition = null;
        }
    }
	
	$scope.ok = function () { $modalInstance.close($scope.treatment); };
	$scope.cancel = function () { $modalInstance.dismiss('cancel'); };

	$scope.calc = { sumOfRatios: 100, firstYearTotal100: true };
	$scope.validateFirstYearRatios = getValidateFirstYearRatios($scope);
	$scope.treatment.$promise.then(function() {
		$scope.validateFirstYearRatios();
	});

	$scope.hasWaitingPeriod = getHasWaitingPeriod($scope);
	$scope.hasWaitingPeriod();
}]);

// ===============================================
// Costs
// ===============================================
PRIMEControllers.controller("Costs", ["$scope", "$location", "$modal", "$controller", "Cost", function ($scope, $location, $modal, $controller, Cost) {
	
	$controller("TabPaneController", {$scope: $scope});
	
	$scope.configureAsTabPane();
	
	$scope.predicate = 'creationDate';
	$scope.reverse = true;
	
	$scope.newCost = function(size) {
		var modalInstance = $modal.open({
			templateUrl: "partials/cost-new.html",
			controller: "NewCost",
			size: size,
			resolve: {
				costs: function () {
					return $scope.costs;
				}
			}
		});

		modalInstance.result.then(function (newCost) {
			new Cost(newCost).$save({}, function(data) {
				$scope.costs.push(data);
				console.log("New cost created: ", data);
			}, function(err) {
				console.log("A database error occurred.");
			});
		}, function () {
			console.log("Create cost modal dismissed at: " + new Date());
		});
	}
	
	$scope.editCostModal = function(size, id) {
		var modalInstance = $modal.open({
			templateUrl: "partials/cost-new.html",
			controller: "EditCostModal",
			size: size,
			resolve: {
				costs: function () { return $scope.costs; },
				costId: function() { return id; },
        viewOnly: function () { return false; }
			}
		});

		modalInstance.result.then(function (editedCost) {
			editedCost.$update({}, function(data) {
				$scope.costs.filter(function(cost, index, costs) {
					if (cost._id === data._id) {
						costs[index] = data;
					}
				});
			}, function(err) {
				console.log("A database error occurred.");
			});
		}, function (reason) {
			console.log("Edit cost modal dismissed at: " + new Date());
		});
	}
	
	$scope.strings = {
		"title":"Type 1 Costs",
		"search":"Search costs",
		"new":"New",
		"delete":"Delete",
		"clone":"Duplicate"
	}
	
	$scope.costs = Cost.query();
	
	$scope.selectedItems = function() {
		var count = 0;
		angular.forEach($scope.costs, function(value){
			if (value.selected) count++;
		});
		return count;
	}

  $scope.hasOwnership = function() {
    let owner = true;
    angular.forEach($scope.costs, function(value){
      if (value.selected && !value.owner) owner = false;
    });

    return owner;
  }
	
	$scope.cloneSelected = function(options) {
		$scope.costs.forEach(function(cost, idx) {
			if (cost.selected) {
				var duplicateCost = angular.copy(cost);
				delete cost.selected;

				delete duplicateCost._id;
				delete duplicateCost.selected;
				duplicateCost.creationDate = new Date().getTime();
				duplicateCost.name = duplicateCost.name + " copy";
				duplicateCost.clonedFrom = cost._id;
				
				duplicateCost.$save({}, function(data) {
					$scope.costs.push(duplicateCost);
					if (options.modal) {
						$scope.editCostModal('lg', duplicateCost._id);
					} else {
						$location.path('/cost/' + duplicateCost._id);
					}
				})
			}
		})
	}
	
	$scope.deleteSelected = function() {
		$scope.costs.forEach(function(cost, idx) {
			if (cost.selected) {
				cost.$delete({}, function(data) {
					$scope.costs = $scope.costs.filter(function(cost) {
						return cost._id !== undefined;
					});
				})
			}
		})
	};
	
}]);

PRIMEControllers.controller("NewCost", ["$scope", "$modalInstance", "Cost", "DefaultCost", function ($scope, $modalInstance, Cost, DefaultCost) {
	
	$scope.strings = {
		"title":"New costs",
		"createButton":"Create new costs",
		"cancelButton":"Cancel"
	}
	
	$scope.cost = new Cost(DefaultCost);
	$scope.cost.creationDate = new Date().getTime();
	$scope.backVisible = false;
	
	$scope.ok = function () { $modalInstance.close($scope.cost); };
	
	$scope.cancel = function () { $modalInstance.dismiss('cancel'); };
	
}]);

PRIMEControllers.controller("EditCost", ["$scope", "$routeParams", "$location", "Cost", function($scope, $routeParams, $location, Cost) {
	$scope.strings = {
		"title":"Cost",
		"createButton":"Save changes",
		"cancelButton":"Cancel"
	}
	$scope.cost = Cost.get({costId:$routeParams.id});
	$scope.backVisible = true;
  $scope.cost.$promise.then(function(cost) {
    $scope.readOnly = !cost.owner;
  });
	
	$scope.ok = function () {
		$scope.cost.$update({}, function(data) {
			$location.path('/costs');
		})
	};

	$scope.cancel = function () {
		$location.path('/costs');
	};
}])

PRIMEControllers.controller("EditCostModal", ["$scope", "$modalInstance", "$routeParams", "$location", "Cost", "costId", "costs", "viewOnly", function($scope, $modalInstance, $routeParams, $location, Cost, costId, costs, viewOnly) {
	$scope.strings = {
		"title":"Cost",
		"createButton":"Save changes",
		"cancelButton":"Cancel"
	}
	
	if (costs !== null) {
		$scope.cost = angular.copy(costs.filter(function(cost){
			return cost._id === costId;
		})[0]);
    $scope.readOnly = viewOnly || !$scope.cost.owner;
	} else {
		$scope.cost = Cost.get({costId:costId});
    $scope.cost.$promise.then(function(cost) {
      $scope.readOnly = viewOnly || !cost.owner;
    })
			.catch(function () {
				$scope.readOnly = true;
			});
	}
	
	$scope.backVisible = false;
	
	$scope.ok = function () { $modalInstance.close($scope.cost); };
	$scope.cancel = function () { $modalInstance.dismiss('cancel'); };
}]);








// ===============================================
// Utilities
// ===============================================
PRIMEControllers.controller("Utilities", ["$scope", "$location", "$modal", "$controller", "Utility", function ($scope, $location, $modal, $controller, Utility) {
	
	$controller("TabPaneController", {$scope: $scope});
	
	$scope.configureAsTabPane();
	
	$scope.predicate = 'creationDate';
	$scope.reverse = true;
	
	$scope.newUtility = function(size) {
		var modalInstance = $modal.open({
			templateUrl: "partials/utility-new.html",
			controller: "NewUtility",
			size: size,
			resolve: {
				utilities: function () {
					return $scope.utilities;
				}
			}
		});

		modalInstance.result.then(function (newUtility) {
			new Utility(newUtility).$save({}, function(data) {
				$scope.utilities.push(data);
				console.log("New utility created: ", data);
			}, function(err) {
				console.log("A database error occurred.");
			});
		}, function () {
			console.log("Create utility modal dismissed at: " + new Date());
		});
	}
	
	
	$scope.editUtilityModal = function(size, id) {
		var modalInstance = $modal.open({
			templateUrl: "partials/utility-new.html",
			controller: "EditUtilityModal",
			size: size,
			resolve: {
				utilities: function () { return $scope.utilities; },
				utilityId: function() { return id; },
        viewOnly: function () { return false; }
			}
		});

		modalInstance.result.then(function (editedUtility) {
			editedUtility.$update({}, function(data) {
				$scope.utilities.filter(function(utility, index, utilities) {
					if (utility._id === data._id) {
						utilities[index] = data;
					}
				});
			}, function(err) {
				console.log("A database error occurred.");
			});
		}, function (reason) {
			console.log("Edit utility modal dismissed at: " + new Date());
		});
	}
	
	$scope.strings = {
		"title":"Type 1 Utilities",
		"search":"Search utilities",
		"new":"New",
		"delete":"Delete",
		"clone":"Duplicate"
	}
	
	$scope.utilities = Utility.query();
	
	$scope.selectedItems = function() {
		var count = 0;
		angular.forEach($scope.utilities, function(value){
			if (value.selected) count++;
		});
		return count;
	}

  $scope.hasOwnership = function() {
    let owner = true;
    angular.forEach($scope.utilities, function(value){
      if (value.selected && !value.owner) owner = false;
    });

    return owner;
  }
	
	$scope.cloneSelected = function(options) {
		$scope.utilities.forEach(function(utility, idx) {
			if (utility.selected) {
				var duplicateUtility = angular.copy(utility);
				delete utility.selected;

				delete duplicateUtility._id;
				delete duplicateUtility.selected;
				duplicateUtility.creationDate = [];
				duplicateUtility.creationDate = new Date().getTime();
				duplicateUtility.name = duplicateUtility.name + " copy";
				duplicateUtility.clonedFrom = utility._id;
				
				duplicateUtility.$save({}, function(data) {
					$scope.utilities.push(duplicateUtility);
					if (options.modal) {
						$scope.editUtilityModal('lg', duplicateUtility._id);
					} else {
						$location.path('/utility/' + duplicateUtility._id);
					}
				})
			}
		})
	}
	
	$scope.deleteSelected = function() {
		$scope.utilities.forEach(function(utility, idx) {
			if (utility.selected) {
				utility.$delete({}, function(data) {
					$scope.utilities = $scope.utilities.filter(function(utility) {
						return utility._id !== undefined;
					});
				})
			}
		})
	};
}]);

PRIMEControllers.controller("NewUtility", ["$scope", "$rootScope", "$modalInstance", "Utility", "DefaultUtility", function ($scope, $rootScope, $modalInstance, Utility, DefaultUtility) {
	
	$scope.strings = {
		"title":"New utility",
		"createButton":"Create new utility",
		"cancelButton":"Cancel"
	}
	$scope.qolCombinationOptions = $rootScope.qolCombinationOptions;
	
	$scope.utility = new Utility(DefaultUtility);
	$scope.utility.creationDate = new Date().getTime();
	$scope.backVisible = false;
	
	$scope.ok = function () { $modalInstance.close($scope.utility); };
	
	$scope.cancel = function () { $modalInstance.dismiss('cancel'); };
	
}]);

PRIMEControllers.controller("EditUtility", ["$scope", "$rootScope", "$routeParams", "$location", "Utility", function($scope, $rootScope, $routeParams, $location, Utility) {
	$scope.strings = {
		"title":"Utility",
		"createButton":"Save changes",
		"cancelButton":"Cancel"
	}
	$scope.qolCombinationOptions = $rootScope.qolCombinationOptions;
	$scope.utility = Utility.get({utilityId:$routeParams.id});
	$scope.backVisible = true;
  $scope.utility.$promise.then(function(utility) {
    $scope.readOnly = !utility.owner;
  });
	
	$scope.ok = function () {
		$scope.utility.$update({}, function(data) {
			$location.path('/utilities');
		})
	};

	$scope.cancel = function () {
		$location.path('/utilities');
	};
}])

PRIMEControllers.controller("EditUtilityModal", ["$scope", "$rootScope", "$modalInstance", "$routeParams", "$location", "Utility", "utilityId", "utilities", "viewOnly", function($scope, $rootScope, $modalInstance, $routeParams, $location, Utility, utilityId, utilities, viewOnly) {
	$scope.strings = {
		"title":"Utility",
		"createButton":"Save changes",
		"cancelButton":"Cancel"
	}
	$scope.qolCombinationOptions = $rootScope.qolCombinationOptions;
	
	if (utilities !== null) {
		$scope.utility = angular.copy(utilities.filter(function(utility){
			return utility._id === utilityId;
		})[0]);
    $scope.readOnly = viewOnly || !$scope.utility.owner;
	} else {
		$scope.utility = Utility.get({utilityId:utilityId});
    $scope.utility.$promise.then(function(utility) {
      $scope.readOnly = viewOnly || !utility.owner;
    })
			.catch(function () {
				$scope.readOnly = true;
			});
	}

	$scope.backVisible = false;
	
	$scope.ok = function () { $modalInstance.close($scope.utility); };
	$scope.cancel = function () { $modalInstance.dismiss('cancel'); };
}]);












// ===============================================
// Countries
// ===============================================

function getMortalityFollowingSeverHypoTrigger($scope) {
	return function() {
		$scope.country.hypoglycemiaMortality = $scope.country.hazardRatios.mortalityFollowingSevereHypoglycemia > 0.0;
	}
}

PRIMEControllers.controller("Countries", ["$scope", "$location", "$modal", "$controller", "Country", "LifeTable", function ($scope, $location, $modal, $controller, Country, LifeTable) {
	
	$controller("TabPaneController", {$scope: $scope});
	
	$scope.configureAsTabPane();
	
	$scope.predicate = 'creationDate';
	$scope.reverse = true;
	
	$scope.newCountry = function(size) {
		var modalInstance = $modal.open({
			templateUrl: "partials/country-new.html?v=1.5.2",
			controller: "NewCountry",
			size: size,
			resolve: {
				countries: function () { return $scope.countries; }
			}
		});

		modalInstance.result.then(function (newCountry) {
			newCountry.$save({}, function(data) {
				$scope.countries.push(newCountry);
				console.log("New country created: ", newCountry);
			}, function(err) {
				console.log("A database error occurred.");
			});
		}, function () {
			console.log("Create country modal dismissed at: " + new Date());
		});
	}
	
	$scope.editCountryModal = function(size, id) {
		var modalInstance = $modal.open({
			templateUrl: "partials/country-new.html?v=1.5.2",
			controller: "EditCountryModal",
			size: size,
			resolve: {
				countries: function () { return $scope.countries; },
				countryId: function() { return id; },
        lifetables: function() {return LifeTable.query(); },
        viewOnly: function () { return false; }
			}
		});

		modalInstance.result.then(function (editedCountry) {
			editedCountry.$update({}, function(data) {
				$scope.countries.filter(function(country, index, countries) {
					if (country._id === data._id) {
						countries[index] = data;
					}
				});
			}, function(err) {
				console.log("A database error occurred.");
			});
		}, function (reason) {
			console.log("Edit country modal dismissed at: " + new Date());
		});
	}
	
	
	$scope.strings = {
		"title":"Type 1 Countries",
		"search":"Search countries",
		"new":"New",
		"delete":"Delete",
		"clone":"Duplicate"
	}
	
	$scope.countries = Country.query();

	$scope.selectedItems = function() {
		var count = 0;
		angular.forEach($scope.countries, function(value){
			if (value.selected) count++;
		});
		return count;
	}

  $scope.hasOwnership = function() {
    let owner = true;
    angular.forEach($scope.countries, function(value){
      if (value.selected && !value.owner) owner = false;
    });

    return owner;
  }
	
	$scope.cloneSelected = function(options) {
		$scope.countries.forEach(function(country, idx) {
			if (country.selected) {
				var duplicateCountry = angular.copy(country);
				delete country.selected;

				delete duplicateCountry._id;
				delete duplicateCountry.selected;
				duplicateCountry.sharedWith = [];
				duplicateCountry.creationDate = new Date().getTime();
				duplicateCountry.name = duplicateCountry.name + " copy";
				duplicateCountry.clonedFrom = country._id;
				
				duplicateCountry.$save({}, function(data) {
					$scope.countries.push(duplicateCountry);
					if (options.modal) {
						$scope.editUtilityModal('lg', duplicateCountry._id);
					} else {
						$location.path('/country/' + duplicateCountry._id);
					}
				})
			}
		})
	}
	
	$scope.deleteSelected = function() {
		$scope.countries.forEach(function(country, idx) {
			if (country.selected) {
				country.$delete({}, function(data) {
					$scope.countries = $scope.countries.filter(function(country) {
						return country._id !== undefined;
					});
				})
			}
		})
	};
}]);

PRIMEControllers.controller("NewCountry", ["$scope", "$rootScope", "$modalInstance", "Country", "DefaultCountry", "LifeTable", "FeatureFlags", function ($scope, $rootScope, $modalInstance, Country, DefaultCountry, LifeTable, FeatureFlags) {
	
	$scope.strings = {
		"title":"New country",
		"createButton":"Create new country",
		"cancelButton":"Cancel"
	}

	$scope.vertexMode = FeatureFlags.vertexMode;

	$scope.cVDModelAveragingOptions = $rootScope.cVDModelAveragingOptions;

	$scope.lifetables = LifeTable.query();
	$scope.country = new Country(DefaultCountry);
	$scope.country.creationDate = new Date().getTime();
	$scope.backVisible = false;
	$scope.mortalityFollowingSeverHypoTrigger = getMortalityFollowingSeverHypoTrigger($scope);

	$scope.ok = function () { $modalInstance.close($scope.country); };
	$scope.cancel = function () { $modalInstance.dismiss('cancel'); };
	
}]);

PRIMEControllers.controller("EditCountry", ["$scope", "$rootScope", "$routeParams", "$location", "Country", "LifeTable", "FeatureFlags", function($scope, $rootScope, $routeParams, $location, Country, LifeTable, FeatureFlags) {
	$scope.strings = {
		"title":"Country",
		"createButton":"Save changes",
		"cancelButton":"Cancel"
	}
	$scope.vertexMode = FeatureFlags.vertexMode;

	$scope.cVDModelAveragingOptions = $rootScope.cVDModelAveragingOptions;
	
	$scope.lifetables = LifeTable.query();
	$scope.country = Country.get({countryId:$routeParams.id});
	$scope.backVisible = true;
  $scope.country.$promise.then(function(country) {
    $scope.readOnly = !country.owner;
  });
	$scope.mortalityFollowingSeverHypoTrigger = getMortalityFollowingSeverHypoTrigger($scope);

	$scope.ok = function () {
		$scope.country.$update({}, function(data) {
			$location.path('/countries');
		})
	};

	$scope.cancel = function () {
		$location.path('/countries');
	};
}])

PRIMEControllers.controller("EditCountryModal", ["$scope", "$rootScope", "$modalInstance", "$routeParams", "$location", "Country", "countryId", "countries", "lifetables", "viewOnly", "FeatureFlags", function($scope, $rootScope, $modalInstance, $routeParams, $location, Country, countryId, countries, lifetables, viewOnly, FeatureFlags) {
	$scope.strings = {
		"title":"Country",
		"createButton":"Save changes",
		"cancelButton":"Cancel"
	}

	$scope.vertexMode = FeatureFlags.vertexMode;

	$scope.cVDModelAveragingOptions = $rootScope.cVDModelAveragingOptions;
	
	$scope.lifetables = lifetables;
	
	if (countries !== null) {
		$scope.country = angular.copy(countries.filter(function(country){
			return country._id === countryId;
		})[0]);
    $scope.readOnly = viewOnly || !$scope.country.owner;
	} else {
		$scope.country = Country.get({countryId:countryId});
    $scope.country.$promise.then(function(country) {
      $scope.readOnly = viewOnly || !country.owner;
    })
			.catch(function () {
				$scope.readOnly = true;
			});
	}

	$scope.backVisible = false;
	$scope.mortalityFollowingSeverHypoTrigger = getMortalityFollowingSeverHypoTrigger($scope);

	$scope.ok = function () { $modalInstance.close($scope.country); };
	$scope.cancel = function () { $modalInstance.dismiss('cancel'); };
}]);









// ===============================================
// Simulations
// ===============================================
PRIMEControllers.controller("Simulations", ["$scope", "$window", "$routeParams", "$location", "$timeout", "$modal", "SimulationService", "ICERCalculator", "Stats", "QueueService", "$http", function ($scope, $window, $routeParams, $location, $timeout, $modal, SimulationService, ICERCalculator, Stats, QueueService, $http) {
  $scope.strings = {
    "title":"Type 1 Simulations",
    "searchSimulations":"Search simulations",
    "new":"New",
    "delete":"Delete",
    "clone":"Duplicate",
		"rerun":"Rerun",
    "export":"Export to Excel"
  };

  // UI state
  $scope.query     = "";     // bound to input
  $scope.page      = 1;
  $scope.pageSize  = 20;
  $scope.total     = 0;
  $scope.totalPages = 1;
  $scope.loading   = false;
  $scope.errorMsg  = null;

  // current page data
  $scope.paged = { items: [] }; // {items, page, pageSize, total, totalPages}

  $scope.icer = ICERCalculator.icer;

  $scope.newSimulation = function() { $location.path("/simulations/new"); };

  // queue polling (unchanged)
  $scope.queueLength = '';
  (function tick() {
    QueueService.get(function(model) {
      $scope.queueLength = model;
      $timeout(tick, 40000);
    });
  })();

  // ---- pagination + search ----
  let searchDebounce;
  $scope.loadPage = function(page, opts) {
    opts = opts || {};
    if (page) $scope.page = page;
    if ($scope.loading  && !opts.force) return;          // prevent double-click spam
    $scope.loading = true;
    $scope.errorMsg = null;

    const params = {
      page: $scope.page,
      pageSize: $scope.pageSize,
      search: $scope.query || undefined
    };

    // IMPORTANT: use $promise so we can .finally()
    SimulationService.queryPaged(params).$promise
      .then(function(res){
        (res.items || []).forEach(function(it){ it.selected = !!it.selected; });
        $scope.paged = res;
        $scope.total = res.total || 0;
        $scope.totalPages = res.totalPages || 1;
      })
      .catch(function(err){
        $scope.paged = { items: [] };
        $scope.total = 0;
        $scope.totalPages = 1;
        $scope.errorMsg = 'Failed to load simulations.';
        console.error(err);
      })
      .finally(function(){
        $scope.loading = false;
      });
  };

  // initial load
  $scope.loadPage(1);

  // debounce search input → restart from page 1
  $scope.$watch("query", function() {
    if (searchDebounce) $timeout.cancel(searchDebounce);
    searchDebounce = $timeout(function(){
      $scope.page = 1;
      $scope.loadPage(1);
    }, 300);
  });

  // selection helpers (work on current page)
  $scope.selectedItems = function() {
    var count = 0;
    angular.forEach($scope.paged.items, function(v){ if (v.selected) count++; });
    return count;
  };
  $scope.hasOwnership = function() {
    var owner = true;
    angular.forEach($scope.paged.items, function(v){ if (v.selected && !v.owner) owner = false; });
    return owner;
  };

  // actions
  $scope.cloneSelected = function() {
    $scope.paged.items.forEach(function(sim){ if (sim.selected) $location.path('/simulations/new/' + sim._id); });
  };

	$scope.rerunSelected = function () {
		var ids = $scope.paged.items
			.filter(function (sim) { return sim.selected; })
			.map(function (sim) { return sim._id; });

		if (!ids.length) return;
		if (!$window.confirm('Rerun ' + ids.length + ' simulation(s)?')) return;

		ids.forEach(function (id) {
			SimulationService.rerun({ simulationId: id }).$promise
				.catch(function (err) {
					// optional: surface a toast / message
					console.error('Rerun failed for', id, err);
				})
				.finally(function () {
					// Backend updates progress/status → just refresh this page
					$scope.loadPage($scope.page);
				});
		});
	};

  $scope.deleteSelected = function () {
    if ($scope.loading) return;

    var ids = $scope.paged.items
      .filter(function (sim) { return sim.selected; })
      .map(function (sim) { return sim._id; });

    if (!ids.length) return;
    if (!$window.confirm('Delete ' + ids.length + ' simulation(s)?')) return;

    $scope.loading = true;
    var remaining = ids.length;

    var allSelectedOnPage = $scope.paged.items.every(function (it) { return it.selected; });
    var targetPage = (allSelectedOnPage && $scope.page > 1) ? ($scope.page - 1) : $scope.page;

    ids.forEach(function (id) {
      SimulationService.delete({ simulationId: id }).$promise
        .catch(function (err) { console.error('Delete failed for', id, err); })
        .finally(function () {
          if (--remaining === 0) $scope.loadPage(targetPage, { force: true });
        });
    });
  };
  $scope.exportSelected = function() {
    var ids = [];
    $scope.paged.items.forEach(function(sim){ if (sim.selected) ids.push(sim._id); });
    if (!ids.length) return;

    $http.post('/api/t1d/simulations/batchexport', {ids: ids}).then(function(res) {
      $modal.open({
        templateUrl: "partials/t2d/export-modal.html?v=2.3.8",
        controller: "ExportT1D",
        size: 'sm',
        resolve: {
          jobId: function() { return res.data.jobId; }
        }
      });
    });
  };
}]);

function findLastNonZero(array) {
	return array.findLast(i => i !== 0);
}

PRIMEControllers.controller("Simulation", ["$scope", "$window", "$rootScope", "$routeParams", "$location", "$modal", "SimulationService", "LifeTable", "ICERCalculator", "Stats", "$http", function ($scope, $window, $rootScope, $routeParams, $location, $modal, SimulationService, LifeTable, ICERCalculator, Stats, $http) {
	$scope.strings = {
		"title":"Simulation",
		"clone":"Duplicate",
		"excelExport":"Export to Excel"
	}
	
	$scope.icer = ICERCalculator.icer;
	
	$scope.clone = function() {
		$location.path('/simulations/new/' + $scope.results._id);
	}

	$scope.export = function() {
		$http.post('/api/t1d/simulations/batchexport', {ids: [$scope.results._id]}).then(function(res) {
			$modal.open({
				templateUrl: "partials/t2d/export-modal.html?v=2.3.7",
				controller: "ExportT1D",
				size: 'sm',
				resolve: {
					jobId: function() { return res.data.jobId; }
				}
			});
		});
	}

	$scope.scenario1Name = "Intervention";
	$scope.scenario2Name = "Comparator";
	$scope.options = {
		aspectRatio: 1.6,
		tooltips: {
			callbacks: {
				label: function(tooltipItem, data) {
					if (typeof tooltipItem.yLabel === "string") {
						return data.datasets[tooltipItem.datasetIndex].label + ": " + tooltipItem.xLabel.toFixed(2);
					} else {
						return data.datasets[tooltipItem.datasetIndex].label + ": " + tooltipItem.yLabel.toFixed(2);	
					}
				}
			}
		},
		legend: { 
			display: true
		},
		scales: {
			xAxes: [{
				ticks: {
					maxTicksLimit: 10,
					maxRotation: 0,
					minRotation: 0
				},
				scaleLabel: {
					display: true,
					labelString: 'Time (years)'
				}
			}],
			yAxes: [{
				ticks: {
					min:0,
					callbacks: function (value) {
						return value.toLocaleString();
					}
				},
				scaleLabel: {
					display: true,
					labelString: ''
				}
			}]
		},
		elements: {
			line: {
				fill: false
			}
		}
	};
	$scope.renalStackedOptions = {
		aspectRatio: 1.6,
		tooltips: {
			callbacks: {
				label: function(tooltipItem, data) {
					return data.datasets[tooltipItem.datasetIndex].label + ": " + tooltipItem.yLabel.toFixed(3);
				}
			}
		},
		legend: { 
			display: true
		},
		scales: {
			xAxes: [{
				ticks: {
					maxTicksLimit: 10,
					maxRotation: 0,
					minRotation: 0
				},
				scaleLabel: {
					display: true,
					labelString: 'Time (years)'
				}
			}],
			yAxes: [{
				stacked: false,
				ticks: {
					min:0,
					callback: function (value) {
						return value.toLocaleString();
					}
				},
				scaleLabel: {
					display: true,
					labelString: 'Cumulative incidence (%)'
				}
			}]
		},
		elements: {
			line: {
				fill: true
			}
		}
	}

	$scope.treatmentLineOptions = {
		type: 'bar',
		segmentShowStroke: false,
		borderWidth: 0,
		aspectRatio: 1.6,
		tooltips: {
			callbacks: {
				label: function(tooltipItem, data) {
					return data.datasets[tooltipItem.datasetIndex].label + ": " + tooltipItem.yLabel.toFixed(3);
				}
			}
		},
		legend: {
			display: true
		},
		scales: {
			xAxes: [{
				stacked: true,
				ticks: {
					maxTicksLimit: 50,
					maxRotation: 0,
					minRotation: 0
				},
				scaleLabel: {
					display: true,
					labelString: 'Time (years)'
				}
			}],
			yAxes: [{
				stacked: true,
				offset: false,
				ticks: {
					beginAtZero: true,
					max:100,
					min:0
				},
				scaleLabel: {
					display: true,
					labelString: "Percentage of patients"
				}
			}]
		},
		elements: {
			line: {
				fill: true
			}
		}
	};

	$scope.reInfusionsLineOptions = angular.copy($scope.treatmentLineOptions);

	$scope.cvdStackedOptions = angular.copy($scope.renalStackedOptions);
	$scope.cvdStackedOptions.scales.yAxes[0].stacked = false;
	$scope.cvdStackedOptions.elements.line.fill = false;
	$scope.cvdStackedOptions.scales.yAxes[0].ticks.max = 100;

	$scope.meAndRetinopathyStackedOptions = angular.copy($scope.renalStackedOptions);
	$scope.meAndRetinopathyStackedOptions.scales.yAxes[0].stacked = false;
	$scope.meAndRetinopathyStackedOptions.elements.line.fill = false;
	//$scope.meAndRetinopathyStackedOptions.scales.yAxes[0].ticks.max = 100;

	$scope.causeOfDeathStackedOptions = angular.copy($scope.renalStackedOptions);
	$scope.causeOfDeathStackedOptions.scales.xAxes[0].stacked = true;
	$scope.causeOfDeathStackedOptions.tooltips.callbacks.label = function(tooltipItem, data) {
		return data.datasets[tooltipItem.datasetIndex].label + ": " + tooltipItem.yLabel.toFixed(0);
	}
	$scope.causeOfDeathStackedOptions.scales.xAxes[0].scaleLabel.display = false;
	$scope.causeOfDeathStackedOptions.scales.yAxes[0].scaleLabel.display = true;
	$scope.causeOfDeathStackedOptions.scales.yAxes[0].scaleLabel.labelString = "Patients (n)";


	$scope.costOptions = angular.copy($scope.renalStackedOptions);
	$scope.costOptions.scales.xAxes[0].stacked = true;
	$scope.costOptions.tooltips.callbacks.label = function(tooltipItem, data) {
		return data.datasets[tooltipItem.datasetIndex].label + ": " + tooltipItem.yLabel.toFixed(0);
	}
	$scope.costOptions.scales.yAxes[0].stacked = true;
	$scope.costOptions.scales.yAxes[0].scaleLabel = {};
	$scope.costOptions.scales.yAxes[0].scaleLabel.display = true;
	$scope.costOptions.scales.yAxes[0].scaleLabel.labelString = 'Cumulative cost';

	$scope.simulations = SimulationService.get({simulationId:$routeParams.id});

	$scope.show = function(size, id, elementType) {
		switch (elementType) {
		case "cohorts":
			$scope.modalInstance = $modal.open({
				templateUrl: "partials/cohort-new.html?v=1.5.3",
				controller: "EditCohortModal",
				size: size,
				resolve: {
					cohorts: function () { return null; },
					cohortId: function() { return id; },
          viewOnly: function () { return true; }
				}
			});
			$scope.modalInstance.result.then(function () {}, function () {});
			break;
		case "treatments":
			$scope.modalInstance = $modal.open({
				templateUrl: "partials/treatment-new.html?v=1.5.3",
				controller: "EditTreatmentModal",
				size: size,
				resolve: {
					treatments: function () { return null; },
					treatmentId: function() { return id; },
          viewOnly: function () { return true; }
				}
			});
			$scope.modalInstance.result.then(function () {}, function () {});
			break;
		case "costs":
			$scope.modalInstance = $modal.open({
				templateUrl: "partials/cost-new.html",
				controller: "EditCostModal",
				size: size,
				resolve: {
					costs: function () { return null; },
					costId: function() { return id; },
          viewOnly: function () { return true; }
				}
			});
			$scope.modalInstance.result.then(function () {}, function () {});
			break;
		case "utilities":
			$scope.modalInstance = $modal.open({
				templateUrl: "partials/utility-new.html",
				controller: "EditUtilityModal",
				size: size,
				resolve: {
					utilities: function () { return null; },
					utilityId: function() { return id; },
          viewOnly: function () { return true; }
				}
			});
			$scope.modalInstance.result.then(function () {}, function () {});
			break;
		case "countries":
			$scope.modalInstance = $modal.open({
				templateUrl: "partials/country-new.html?v=1.5.2",
				controller: "EditCountryModal",
				size: size,
				resolve: {
					countries: function () { return null; },
					countryId: function() { return id; },
					lifetables: function() {return LifeTable.query(); },
          viewOnly: function () { return true; }
				}
			});
			$scope.modalInstance.result.then(function () {}, function () {});
			break;
		}
	}

  $rootScope.pluralMap = {
    cohorts:    { '0':'Cohorts',  'one':'Cohort',  'other':'Cohorts' },
    treatments: { '0':'Treatments','one':'Treatment','other':'Treatments' },
    costs:      { '0':'Costs',    'one':'Cost',    'other':'Costs' },
    utilities:  { '0':'Utilities','one':'Utility', 'other':'Utilities' },
    countries:  { '0':'Countries','one':'Country', 'other':'Countries' }
  };
	
	$scope.simulations.$promise.then(function(data) {
		$scope.results = data;
		$scope.dLifeExpectancy1 = findLastNonZero(data.arms['1'].totalDiscountedLE);
		$scope.uLifeExpectancy1 = findLastNonZero(data.arms['1'].totalUndiscountedLE);
		$scope.dLifeExpectancy2 = findLastNonZero(data.arms['0'].totalDiscountedLE);
		$scope.uLifeExpectancy2 = findLastNonZero(data.arms['0'].totalUndiscountedLE);
		$scope.dQale1 = findLastNonZero(data.arms['1'].totalDiscountedQALE);
		$scope.uQale1 = findLastNonZero(data.arms['1'].totalUndiscountedQALE);
		$scope.dQale2 = findLastNonZero(data.arms['0'].totalDiscountedQALE);
		$scope.uQale2 = findLastNonZero(data.arms['0'].totalUndiscountedQALE);
		$scope.dCost1 = findLastNonZero(data.arms['1'].totalDiscountedCost) / data.patients;
		$scope.uCost1 = findLastNonZero(data.arms['1'].totalUndiscountedCost) / data.patients;
		$scope.dCost2 = findLastNonZero(data.arms['0'].totalDiscountedCost) / data.patients;
		$scope.uCost2 = findLastNonZero(data.arms['0'].totalUndiscountedCost) / data.patients;
		if ($scope.results.randomSeed === undefined) $scope.results.randomSeed = 31415;
		$scope.labels = [];
		for (var i = 0; i <= data.timeHorizon; i++) {
			$scope.labels.push(i);
		}
    for (var element in $scope.results.fullElements) {
      if (!$scope.results.fullElements.hasOwnProperty(element)) continue;
      $scope.results.fullElements[element].pluralize = ($rootScope.pluralMap || {})[element];
    }

		$scope.twoLineColors = [
			{ backgroundColor: '#f6d4c9', borderColor: '#f74902', pointBackgroundColor: '#f74902', hoverBackgroundColor: '#f6d4c9', hoverBorderColor: '#f74902', pointHoverBackgroundColor: '#f6d4c9', pointHoverBorderColor: '#f74902' },
			{ backgroundColor: '#e2e2e2', borderColor: '#999999', pointBackgroundColor: '#999999', hoverBackgroundColor: '#e2e2e2', hoverBorderColor: '#999999', pointHoverBackgroundColor: '#e2e2e2', pointHoverBorderColor: '#999999' },
		];
		$scope.cumulativeOptions = angular.copy($scope.options);
		$scope.cumulativeOptions.scales.yAxes[0].scaleLabel.labelString = "Cumulative incidence (%)";
		$scope.cumulativeOptions.scales.yAxes[0].ticks.max = 100;


		$scope.series = [$scope.scenario1Name, $scope.scenario2Name];

		$scope.proportionsToPercentage = (proportions) => proportions.map(p => p * 100);
		$scope.proportions2DToPercentage = (matrix) => matrix.map((proportions) => $scope.proportionsToPercentage(proportions));

		$scope.survivalCurves = $scope.proportions2DToPercentage([data.arms['1'].survivalOverTime, data.arms['0'].survivalOverTime]);
		$scope.survivalOptions = angular.copy($scope.options);
		$scope.survivalOptions.scales.yAxes[0].scaleLabel.labelString = "Percentage alive";
		$scope.hbA1cCurves = [data.arms['1'].meanHbA1cOverTime, data.arms['0'].meanHbA1cOverTime];
		$scope.hbA1cOptions = angular.copy($scope.options);
		$scope.hbA1cOptions.scales.yAxes[0].scaleLabel.labelString = "HbA1c (%)";
		$scope.sBPCurves = [data.arms['1'].meanSBPOverTime, data.arms['0'].meanSBPOverTime];
		$scope.sBPOptions = angular.copy($scope.options);
		$scope.sBPOptions.scales.yAxes[0].scaleLabel.labelString = "SBP (mmHg)";
		$scope.bMICurves = [data.arms['1'].meanBMIOverTime, data.arms['0'].meanBMIOverTime];
		$scope.bMIOptions = angular.copy($scope.options);
		$scope.bMIOptions.scales.yAxes[0].scaleLabel.labelString = "BMI (kg/m\u00B2)";
		$scope.totalCholesterolCurves = [data.arms['1'].meanTotalCholesterolOverTime, data.arms['0'].meanTotalCholesterolOverTime];
		$scope.tCholOptions = angular.copy($scope.options);
		$scope.tCholOptions.scales.yAxes[0].scaleLabel.labelString = "Total cholesterol (mmol/L)";
		$scope.hdlCholesterolCurves = [data.arms['1'].meanHDLOverTime, data.arms['0'].meanHDLOverTime];
		$scope.hdlOptions = angular.copy($scope.options);
		$scope.hdlOptions.scales.yAxes[0].scaleLabel.labelString = "HDL cholesterol (mmol/L)";
		$scope.severeHypoglycemia = [data.arms['1'].severeHypoRatesOverTime, data.arms['0'].severeHypoRatesOverTime];
		$scope.eventsOptions = angular.copy($scope.options);
		$scope.eventsOptions.scales.yAxes[0].scaleLabel.labelString = "Events per patient per year";
		$scope.nonSevereHypoglycemia = [data.arms['1'].nonSevereHypoRatesOverTime, data.arms['0'].nonSevereHypoRatesOverTime];
		$scope.ketoacidosis = [data.arms['1'].ketoacidosisRatesOverTime, data.arms['0'].ketoacidosisRatesOverTime];
		$scope.reInfusions = [data.arms['1'].cumulativeNumberOfReInfusions, data.arms['0'].cumulativeNumberOfReInfusions];
		$scope.reInfusionsOptions = angular.copy($scope.options);
		$scope.reInfusionsOptions.scales.yAxes[0].scaleLabel.labelString = "Mean number of re-infusions per patient";
		
		$scope.discountedCostBreakdown = true;
		
		($scope.recalcCostBreakdown = function() {
			if (data.arms['0'].costsOverTime !== undefined) {
			
				$scope.cvdCost = [0],
				$scope.renalCost = [0],
				$scope.treatmentsCost = [0],
				$scope.adverseEventCost = [0],
				$scope.ocularCost = [0],
				$scope.neuropathyAmpCost = [0],
				$scope.cvdCost2 = [0],
				$scope.renalCost2 = [0],
				$scope.treatmentsCost2 = [0],
				$scope.adverseEventCost2 = [0],
				$scope.ocularCost2 = [0],
				$scope.neuropathyAmpCost2 = [0];
		
				$scope.miCost1 = [0],
				$scope.strokeCost1 = [0],
				$scope.anginaCost1 = [0],
				$scope.chfCost1 = [0],
				$scope.retinopathyCost1 = [0],
				$scope.macularEdemaCost1 = [0],
				$scope.neuropathyCost1 = [0],
				$scope.amputationCost1 = [0],
				$scope.renalCost1 = [0],
				$scope.hypoglycemiaCost1 = [0],
				$scope.ketoacidosisCost1 = [0],
				$scope.treatmentCost1 = [0],
				$scope.concomitantCost1 = [0],
				$scope.miCost2 = [0],
				$scope.strokeCost2 = [0],
				$scope.anginaCost2 = [0],
				$scope.chfCost2 = [0],
				$scope.retinopathyCost2 = [0],
				$scope.macularEdemaCost2 = [0],
				$scope.neuropathyCost2 = [0],
				$scope.amputationCost2 = [0],
				$scope.renalCost2 = [0],
				$scope.hypoglycemiaCost2 = [0],
				$scope.ketoacidosisCost2 = [0],
				$scope.treatmentCost2 = [0],
				$scope.concomitantCost2 = [0],
				$scope.indirectCost1 = [0],
				$scope.indirectCost2 = [0],
				$scope.compFreeCost1 = [0],
				$scope.compFreeCost2 = [0],
				$scope.unrelatedMedCost1 = [0],
				$scope.unrelatedMedCost2 = [0],
				$scope.otherCost = [0],
				$scope.otherCost2 = [0]
				;
			
				var disc1 = $scope.discountedCostBreakdown ? (1 + data.fullElements.countries[0].costDiscountRate / 100) : 1,
					disc2 = $scope.discountedCostBreakdown ? (data.fullElements.countries.length > 1 ? (1 + data.fullElements.countries[1].costDiscountRate / 100) : (1 + data.fullElements.countries[0].costDiscountRate / 100)) : 1;
				
				Object.keys(data.arms['0'].costsOverTime).forEach(function(key) {
					Object.keys(data.arms['0'].costsOverTime[key].stateProportionMap).forEach(function(costCategory) {
						switch (costCategory) {
							case "AMP":
								$scope.neuropathyAmpCost.push($scope.neuropathyAmpCost[$scope.neuropathyAmpCost.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1) + data.arms['0'].costsOverTime[key].stateProportionMap['NEURO'] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.neuropathyAmpCost2.push($scope.neuropathyAmpCost2[$scope.neuropathyAmpCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1) + data.arms['1'].costsOverTime[key].stateProportionMap['NEURO'] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
							
								$scope.amputationCost1.push($scope.amputationCost1[$scope.amputationCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.amputationCost2.push($scope.amputationCost2[$scope.amputationCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "ANGINA":
								$scope.cvdCost.push($scope.cvdCost[$scope.cvdCost.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1) + data.arms['0'].costsOverTime[key].stateProportionMap['CHF'] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1) + data.arms['0'].costsOverTime[key].stateProportionMap['MI'] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1) + data.arms['0'].costsOverTime[key].stateProportionMap['STROKE'] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.cvdCost2.push($scope.cvdCost2[$scope.cvdCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1) + data.arms['1'].costsOverTime[key].stateProportionMap['CHF'] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1) + data.arms['1'].costsOverTime[key].stateProportionMap['MI'] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1) + data.arms['1'].costsOverTime[key].stateProportionMap['STROKE'] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1))
							
								$scope.anginaCost1.push($scope.anginaCost1[$scope.anginaCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.anginaCost2.push($scope.anginaCost2[$scope.anginaCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "CHF":
								$scope.chfCost1.push($scope.chfCost1[$scope.chfCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.chfCost2.push($scope.chfCost2[$scope.chfCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "CONC_MEDS":
								$scope.concomitantCost1.push($scope.concomitantCost1[$scope.concomitantCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.concomitantCost2.push($scope.concomitantCost2[$scope.concomitantCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "HYPO":
								$scope.adverseEventCost.push($scope.adverseEventCost[$scope.adverseEventCost.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1) + data.arms['0'].costsOverTime[key].stateProportionMap['KETO'] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.adverseEventCost2.push($scope.adverseEventCost2[$scope.adverseEventCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1) + data.arms['1'].costsOverTime[key].stateProportionMap['KETO'] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
							
								$scope.hypoglycemiaCost1.push($scope.hypoglycemiaCost1[$scope.hypoglycemiaCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.hypoglycemiaCost2.push($scope.hypoglycemiaCost2[$scope.hypoglycemiaCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "KETO":
								$scope.ketoacidosisCost1.push($scope.ketoacidosisCost1[$scope.ketoacidosisCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.ketoacidosisCost2.push($scope.ketoacidosisCost2[$scope.ketoacidosisCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "ME":
								$scope.ocularCost.push($scope.ocularCost[$scope.ocularCost.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1) + data.arms['0'].costsOverTime[key].stateProportionMap['RETINOPATHY'] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.ocularCost2.push($scope.ocularCost2[$scope.ocularCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1) + data.arms['1'].costsOverTime[key].stateProportionMap['RETINOPATHY'] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
							
								$scope.macularEdemaCost1.push($scope.macularEdemaCost1[$scope.macularEdemaCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.macularEdemaCost2.push($scope.macularEdemaCost2[$scope.macularEdemaCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "MI":
								$scope.miCost1.push($scope.miCost1[$scope.miCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.miCost2.push($scope.miCost2[$scope.miCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "NEPHRO":
								$scope.renalCost1.push($scope.renalCost1[$scope.renalCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.renalCost2.push($scope.renalCost2[$scope.renalCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "NEURO":
								$scope.neuropathyCost1.push($scope.neuropathyCost1[$scope.neuropathyCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.neuropathyCost2.push($scope.neuropathyCost2[$scope.neuropathyCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "RETINOPATHY":
								$scope.retinopathyCost1.push($scope.retinopathyCost1[$scope.retinopathyCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.retinopathyCost2.push($scope.retinopathyCost2[$scope.retinopathyCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "RX":
								$scope.treatmentsCost.push($scope.treatmentsCost[$scope.treatmentsCost.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1) + data.arms['0'].costsOverTime[key].stateProportionMap['CONC_MEDS'] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.treatmentsCost2.push($scope.treatmentsCost2[$scope.treatmentsCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1) + data.arms['1'].costsOverTime[key].stateProportionMap['CONC_MEDS'] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
							
								$scope.treatmentCost1.push($scope.treatmentCost1[$scope.treatmentCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.treatmentCost2.push($scope.treatmentCost2[$scope.treatmentCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "STROKE":
								$scope.strokeCost1.push($scope.strokeCost1[$scope.strokeCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] / data.patients / Math.pow(disc1, parseInt(key) - 1));
								$scope.strokeCost2.push($scope.strokeCost2[$scope.strokeCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] / data.patients / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "INDIRECT":
								$scope.indirectCost1.push($scope.indirectCost1[$scope.indirectCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] / data.patients / Math.pow(disc1, parseInt(key) - 1));
								$scope.indirectCost2.push($scope.indirectCost2[$scope.indirectCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] / data.patients / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "COMP_FREE":
								$scope.compFreeCost1.push($scope.compFreeCost1[$scope.compFreeCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] / data.patients / Math.pow(disc1, parseInt(key) - 1));
								$scope.compFreeCost2.push($scope.compFreeCost2[$scope.compFreeCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] / data.patients / Math.pow(disc2, parseInt(key) - 1));

								$scope.otherCost.push($scope.otherCost[$scope.otherCost.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] / data.patients / Math.pow(disc1, parseInt(key) - 1) + data.arms['0'].costsOverTime[key].stateProportionMap['UNRELATED_MED'] / data.patients / Math.pow(disc1, parseInt(key) - 1));
								$scope.otherCost2.push($scope.otherCost2[$scope.otherCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] / data.patients / Math.pow(disc2, parseInt(key) - 1) + data.arms['1'].costsOverTime[key].stateProportionMap['UNRELATED_MED'] / data.patients / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "UNRELATED_MED":
								$scope.unrelatedMedCost1.push($scope.unrelatedMedCost1[$scope.unrelatedMedCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] / data.patients / Math.pow(disc1, parseInt(key) - 1));
								$scope.unrelatedMedCost2.push($scope.unrelatedMedCost2[$scope.unrelatedMedCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] / data.patients / Math.pow(disc2, parseInt(key) - 1));
								break;
						}
					})
				});
			
				$scope.costSeries = [ "Cardiovascular disease", "Renal", "Treatment", "Adverse events", "Ocular complications", "Neuropathy and amputation", "Indirect", "Routine care"];

				$scope.costCurve1 = [ $scope.cvdCost2, $scope.renalCost2, $scope.treatmentsCost2, $scope.adverseEventCost2, $scope.ocularCost2, $scope.neuropathyAmpCost2, $scope.indirectCost2, $scope.otherCost2 ];
				$scope.costCurve2 = [ $scope.cvdCost, $scope.renalCost, $scope.treatmentsCost, $scope.adverseEventCost, $scope.ocularCost, $scope.neuropathyAmpCost, $scope.indirectCost1, $scope.otherCost ];
			}
		})();
		
		
		$scope.causeOfDeathLabels = ["Background", "Angina", "Myocardial infarction", "Stroke", "ESRD", "Hypoglycemia", "Ketoacidosis"];
		$scope.causeOfDeath = [
			[
				data.arms['1'].maleCauseOfDeathOverTime[data.timeHorizon].stateProportionMap.BACKGROUND + data.arms['1'].femaleCauseOfDeathOverTime[data.timeHorizon].stateProportionMap.BACKGROUND,
				data.arms['0'].maleCauseOfDeathOverTime[data.timeHorizon].stateProportionMap.BACKGROUND + data.arms['0'].femaleCauseOfDeathOverTime[data.timeHorizon].stateProportionMap.BACKGROUND
			],
			[
				data.arms['1'].maleCauseOfDeathOverTime[data.timeHorizon].stateProportionMap.ANGINA + data.arms['1'].femaleCauseOfDeathOverTime[data.timeHorizon].stateProportionMap.ANGINA,
				data.arms['0'].maleCauseOfDeathOverTime[data.timeHorizon].stateProportionMap.ANGINA + data.arms['0'].femaleCauseOfDeathOverTime[data.timeHorizon].stateProportionMap.ANGINA
			],
			[
				data.arms['1'].maleCauseOfDeathOverTime[data.timeHorizon].stateProportionMap.MI + data.arms['1'].femaleCauseOfDeathOverTime[data.timeHorizon].stateProportionMap.MI,
				data.arms['0'].maleCauseOfDeathOverTime[data.timeHorizon].stateProportionMap.MI + data.arms['0'].femaleCauseOfDeathOverTime[data.timeHorizon].stateProportionMap.MI
			],
			[
				data.arms['1'].maleCauseOfDeathOverTime[data.timeHorizon].stateProportionMap.STROKE + data.arms['1'].femaleCauseOfDeathOverTime[data.timeHorizon].stateProportionMap.STROKE,
				data.arms['0'].maleCauseOfDeathOverTime[data.timeHorizon].stateProportionMap.STROKE + data.arms['0'].femaleCauseOfDeathOverTime[data.timeHorizon].stateProportionMap.STROKE
			],
			[
				data.arms['1'].maleCauseOfDeathOverTime[data.timeHorizon].stateProportionMap.ESRD + data.arms['1'].femaleCauseOfDeathOverTime[data.timeHorizon].stateProportionMap.ESRD,
				data.arms['0'].maleCauseOfDeathOverTime[data.timeHorizon].stateProportionMap.ESRD + data.arms['0'].femaleCauseOfDeathOverTime[data.timeHorizon].stateProportionMap.ESRD
			],
			[
				data.arms['1'].maleCauseOfDeathOverTime[data.timeHorizon].stateProportionMap.HYPOGLYCEMIA + data.arms['1'].femaleCauseOfDeathOverTime[data.timeHorizon].stateProportionMap.HYPOGLYCEMIA,
				data.arms['0'].maleCauseOfDeathOverTime[data.timeHorizon].stateProportionMap.HYPOGLYCEMIA + data.arms['0'].femaleCauseOfDeathOverTime[data.timeHorizon].stateProportionMap.HYPOGLYCEMIA
			],
			[
				data.arms['1'].maleCauseOfDeathOverTime[data.timeHorizon].stateProportionMap.KETOACIDOSIS + data.arms['1'].femaleCauseOfDeathOverTime[data.timeHorizon].stateProportionMap.KETOACIDOSIS,
				data.arms['0'].maleCauseOfDeathOverTime[data.timeHorizon].stateProportionMap.KETOACIDOSIS + data.arms['0'].femaleCauseOfDeathOverTime[data.timeHorizon].stateProportionMap.KETOACIDOSIS
			]
		];
		
		$scope.complicationColors = [ '#4D5360', '#888888', '#803690', '#00ADF9', '#52996b', '#46BFBD', '#FDB45C' ];
		
		$scope.complicationCumulativeIncidenceLabels = ["Myocardial Infarction", "Stroke", "Angina", "Congestive heart failure", "Microalbuminuria", "Overt nephropathy", "End-stage renal disease", "Amputation", "Neuropathy", "Macular edema", "Non-proliferative diabetic retinopathy", "Proliferative diabetic retinopathy", "Severe vision loss"];
		
		$scope.complicationCumulativeIncidenceOptions = angular.copy($scope.options);
		$scope.complicationCumulativeIncidenceOptions.scales.xAxes[0].scaleLabel.labelString = "Cumulative incidence (%)";
		$scope.complicationCumulativeIncidenceOptions.aspectRatio = 1.25;
		$scope.complicationCumulativeIncidenceOptions.tooltips.callbacks.label =  function(tooltipItem, data) {
					if (typeof tooltipItem.yLabel === "string") {
						return data.datasets[tooltipItem.datasetIndex].label + ": " + tooltipItem.xLabel.toFixed(3);
					} else {
						return data.datasets[tooltipItem.datasetIndex].label + ": " + tooltipItem.yLabel.toFixed(3);	
					}
				};
		
		$scope.complicationCumulativeIncidence = [
			[
				data.arms['1'].cumulativeIncidenceMIOverTime[data.arms['1'].cumulativeIncidenceMIOverTime.length - 1],
				data.arms['1'].cumulativeIncidenceStrokeOverTime[data.arms['1'].cumulativeIncidenceStrokeOverTime.length - 1],
				data.arms['1'].cumulativeIncidenceAnginaOverTime[data.arms['1'].cumulativeIncidenceAnginaOverTime.length - 1],
				data.arms['1'].cumulativeIncidenceCHFOverTime[data.arms['1'].cumulativeIncidenceCHFOverTime.length - 1],
				data.arms['1'].cumulativeIncidenceMAOverTime[data.arms['1'].cumulativeIncidenceMAOverTime.length - 1],
				data.arms['1'].cumulativeIncidenceOvertNephropathyOverTime[data.arms['1'].cumulativeIncidenceOvertNephropathyOverTime.length - 1],
				data.arms['1'].cumulativeIncidenceESRDOverTime[data.arms['1'].cumulativeIncidenceESRDOverTime.length - 1],
				data.arms['1'].cumulativeIncidenceAmputationOverTime[data.arms['1'].cumulativeIncidenceAmputationOverTime.length - 1],
				data.arms['1'].cumulativeIncidenceNeuropathyOverTime[data.arms['1'].cumulativeIncidenceNeuropathyOverTime.length - 1],
				data.arms['1'].cumulativeIncidenceMacularEdemaOverTime[data.arms['1'].cumulativeIncidenceMacularEdemaOverTime.length - 1],
				data.arms['1'].retinopathyStatesOverTime[data.timeHorizon].stateProportionMap.MILD_NPDR + data.arms['1'].retinopathyStatesOverTime[data.timeHorizon].stateProportionMap.MODERATE_NPDR + data.arms['1'].retinopathyStatesOverTime[data.timeHorizon].stateProportionMap.SEVERE_NPDR,
				data.arms['1'].retinopathyStatesOverTime[data.timeHorizon].stateProportionMap.PDR,
				data.arms['1'].retinopathyStatesOverTime[data.timeHorizon].stateProportionMap.SVL
			],
			[
				data.arms['0'].cumulativeIncidenceMIOverTime[data.arms['0'].cumulativeIncidenceMIOverTime.length - 1],
				data.arms['0'].cumulativeIncidenceStrokeOverTime[data.arms['0'].cumulativeIncidenceStrokeOverTime.length - 1],
				data.arms['0'].cumulativeIncidenceAnginaOverTime[data.arms['0'].cumulativeIncidenceAnginaOverTime.length - 1],
				data.arms['0'].cumulativeIncidenceCHFOverTime[data.arms['0'].cumulativeIncidenceCHFOverTime.length - 1],
				data.arms['0'].cumulativeIncidenceMAOverTime[data.arms['0'].cumulativeIncidenceMAOverTime.length - 1],
				data.arms['0'].cumulativeIncidenceOvertNephropathyOverTime[data.arms['0'].cumulativeIncidenceOvertNephropathyOverTime.length - 1],
				data.arms['0'].cumulativeIncidenceESRDOverTime[data.arms['0'].cumulativeIncidenceESRDOverTime.length - 1],
				data.arms['0'].cumulativeIncidenceAmputationOverTime[data.arms['0'].cumulativeIncidenceAmputationOverTime.length - 1],
				data.arms['0'].cumulativeIncidenceNeuropathyOverTime[data.arms['0'].cumulativeIncidenceNeuropathyOverTime.length - 1],
				data.arms['0'].cumulativeIncidenceMacularEdemaOverTime[data.arms['0'].cumulativeIncidenceMacularEdemaOverTime.length - 1],
				data.arms['0'].retinopathyStatesOverTime[data.timeHorizon].stateProportionMap.MILD_NPDR + data.arms['0'].retinopathyStatesOverTime[data.timeHorizon].stateProportionMap.MODERATE_NPDR + data.arms['0'].retinopathyStatesOverTime[data.timeHorizon].stateProportionMap.SEVERE_NPDR,
				data.arms['0'].retinopathyStatesOverTime[data.timeHorizon].stateProportionMap.PDR,
				data.arms['0'].retinopathyStatesOverTime[data.timeHorizon].stateProportionMap.SVL
			]
		];
		$scope.complicationCumulativeIncidence = $scope.proportions2DToPercentage($scope.complicationCumulativeIncidence);
		
		$scope.nephropathySeries = ["Microalbuminuria", "Overt nephropathy", "End-stage renal disease"];
		
		($scope.rescaleNephropathy = function() {
			$scope.renalStackedOptions.elements.line.fill = $scope.renalStackedOptions.scales.yAxes['0'].stacked;
			
			var allValues = [];
			if ($scope.renalStackedOptions.scales.yAxes[0].stacked) {
				data.arms['0'].cumulativeIncidenceMAOverTime.forEach(function(val, i, arr) {
					allValues.push(val + data.arms['0'].cumulativeIncidenceOvertNephropathyOverTime[i] + data.arms['0'].cumulativeIncidenceESRDOverTime[i]);
				});	
			} else {
				allValues = data.arms['0'].cumulativeIncidenceMAOverTime
					.concat(data.arms['0'].cumulativeIncidenceOvertNephropathyOverTime)
					.concat(data.arms['0'].cumulativeIncidenceESRDOverTime)
					.concat(data.arms['1'].cumulativeIncidenceMAOverTime)
					.concat(data.arms['1'].cumulativeIncidenceOvertNephropathyOverTime)
					.concat(data.arms['1'].cumulativeIncidenceESRDOverTime);	
			}
		
			$scope.renalStackedOptions.scales.yAxes[0].ticks.suggestedMax = allValues.reduce(function(a, b) {
				return Math.max(a, b);
			}) * 1.05;
		})();

		$scope.renalStackedOptions.scales.yAxes[0].ticks.max = 100;

		$scope.nephropathyCurve1 = $scope.proportions2DToPercentage([data.arms['1'].cumulativeIncidenceMAOverTime, data.arms['1'].cumulativeIncidenceOvertNephropathyOverTime, data.arms['1'].cumulativeIncidenceESRDOverTime]);
		$scope.nephropathyCurve2 = $scope.proportions2DToPercentage([data.arms['0'].cumulativeIncidenceMAOverTime, data.arms['0'].cumulativeIncidenceOvertNephropathyOverTime, data.arms['0'].cumulativeIncidenceESRDOverTime]);

		$scope.cvdSeries = ["Congestive heart failure", "Myocardial infarction", "Stroke", "Angina", ];
		
		($scope.rescaleCVD = function() {
			$scope.cvdStackedOptions.elements.line.fill = $scope.cvdStackedOptions.scales.yAxes['0'].stacked;
			
			var allValues = [];
			if ($scope.cvdStackedOptions.scales.yAxes[0].stacked) {
				data.arms['0'].cumulativeIncidenceMIOverTime.forEach(function(val, i, arr) {
					allValues.push(val + data.arms['0'].cumulativeIncidenceStrokeOverTime[i] + data.arms['0'].cumulativeIncidenceAnginaOverTime[i]);
				});	
			} else {
				allValues = data.arms['0'].cumulativeIncidenceCHFOverTime
					.concat(data.arms['0'].cumulativeIncidenceMIOverTime)
					.concat(data.arms['0'].cumulativeIncidenceStrokeOverTime)
					.concat(data.arms['0'].cumulativeIncidenceAnginaOverTime)
					.concat(data.arms['1'].cumulativeIncidenceCHFOverTime)
					.concat(data.arms['1'].cumulativeIncidenceMIOverTime)
					.concat(data.arms['1'].cumulativeIncidenceStrokeOverTime)
					.concat(data.arms['1'].cumulativeIncidenceAnginaOverTime);
			}
		
			$scope.cvdStackedOptions.scales.yAxes[0].ticks.suggestedMax = allValues.reduce(function(a, b) {
				return Math.max(a, b);
			}) * 1.05;	
		})();
		$scope.cvdStackedOptions.scales.yAxes[0].scaleLabel = {};
		$scope.cvdStackedOptions.scales.yAxes[0].scaleLabel.display = true;
		$scope.cvdStackedOptions.scales.yAxes[0].scaleLabel.labelString = "Cumulative incidence (%)";

		$scope.cvdCurve1 = $scope.proportions2DToPercentage([data.arms['1'].cumulativeIncidenceCHFOverTime, data.arms['1'].cumulativeIncidenceMIOverTime, data.arms['1'].cumulativeIncidenceStrokeOverTime, data.arms['1'].cumulativeIncidenceAnginaOverTime]);
		$scope.cvdCurve2 = $scope.proportions2DToPercentage([data.arms['0'].cumulativeIncidenceCHFOverTime, data.arms['0'].cumulativeIncidenceMIOverTime, data.arms['0'].cumulativeIncidenceStrokeOverTime, data.arms['0'].cumulativeIncidenceAnginaOverTime]);

		$scope.retinopathySeries = ["Macular edema", "No retinopathy", "Mild NPDR", "Moderate NPDR", "Severe NPDR", "PDR", "SVL"];

		$scope.calculateMeAndRetinopathyCurves = function(data) {
			let meAndRetinopathyCurve1 = [data.arms['1'].cumulativeIncidenceMacularEdemaOverTime];
			let meAndRetinopathyCurve2 = [data.arms['0'].cumulativeIncidenceMacularEdemaOverTime];

			const states = ['NO', 'MILD_NPDR', 'MODERATE_NPDR', 'SEVERE_NPDR', 'PDR', 'SVL'];
			states.forEach(function(state) {
				const stateData1 = [];
				const stateData0 = [];

				Object.keys(data.arms['1'].retinopathyStatesOverTime).forEach(function(year) {
					stateData1.push(data.arms['1'].retinopathyStatesOverTime[year].stateProportionMap[state]);
				});
				Object.keys(data.arms['0'].retinopathyStatesOverTime).forEach(function(year) {
					stateData0.push(data.arms['0'].retinopathyStatesOverTime[year].stateProportionMap[state]);
				});
				meAndRetinopathyCurve1.push(stateData1);
				meAndRetinopathyCurve2.push(stateData0);
			});

			return [meAndRetinopathyCurve1, meAndRetinopathyCurve2];
		};

		const retinopathyCurves = $scope.calculateMeAndRetinopathyCurves(data);
		$scope.meAndRetinopathyCurve1 = $scope.proportions2DToPercentage(retinopathyCurves[0]);
		$scope.meAndRetinopathyCurve2 = $scope.proportions2DToPercentage(retinopathyCurves[1]);

		// Store original curves for toggling between stacked and non-stacked
		$scope.meAndRetinopathyCurve1Original = JSON.parse(JSON.stringify($scope.meAndRetinopathyCurve1));
		$scope.meAndRetinopathyCurve2Original = JSON.parse(JSON.stringify($scope.meAndRetinopathyCurve2));

		$scope.rescaleMeAndRetinopathy = function() {
			$scope.meAndRetinopathyStackedOptions.elements.line.fill = $scope.meAndRetinopathyStackedOptions.scales.yAxes['0'].stacked;

			let allValues = [];
			if ($scope.meAndRetinopathyStackedOptions.scales.yAxes[0].stacked) {
				// For stacked mode: convert to cumulative values across series
				const cumulativeCurve1 = [];
				const cumulativeCurve2 = [];
				const numYears = $scope.meAndRetinopathyCurve1Original[0].length;

				// Create stacked series by accumulating at each position
				for (let seriesIdx = 0; seriesIdx < $scope.meAndRetinopathyCurve1Original.length; seriesIdx++) {
					const stackedSeries1 = [];
					const stackedSeries2 = [];

					for (let yearIdx = 0; yearIdx < numYears; yearIdx++) {
						let sum1 = 0;
						let sum2 = 0;

						for (let i = 0; i <= seriesIdx; i++) {
							sum1 += $scope.meAndRetinopathyCurve1Original[i][yearIdx];
							sum2 += $scope.meAndRetinopathyCurve2Original[i][yearIdx];
						}

						stackedSeries1.push(sum1);
						stackedSeries2.push(sum2);
					}

					cumulativeCurve1.push(stackedSeries1);
					cumulativeCurve2.push(stackedSeries2);
					allValues = allValues.concat(stackedSeries1);
					allValues = allValues.concat(stackedSeries2);
				}

				$scope.meAndRetinopathyCurve1 = cumulativeCurve1;
				$scope.meAndRetinopathyCurve2 = cumulativeCurve2;
				$scope.meAndRetinopathyStackedOptions.scales.yAxes[0].stacked = false;
			} else {
				// For unstacked mode: restore original percentages
				$scope.meAndRetinopathyCurve1 = JSON.parse(JSON.stringify($scope.meAndRetinopathyCurve1Original));
				$scope.meAndRetinopathyCurve2 = JSON.parse(JSON.stringify($scope.meAndRetinopathyCurve2Original));

				$scope.meAndRetinopathyCurve1.forEach(function(series) {
					allValues = allValues.concat(series);
				});
				$scope.meAndRetinopathyCurve2.forEach(function(series) {
					allValues = allValues.concat(series);
				});
			}

			$scope.meAndRetinopathyStackedOptions.scales.yAxes[0].ticks.suggestedMax = allValues.reduce(function(a, b) {
				return Math.max(a, b);
			}) * 1.05;
		};
		$scope.meAndRetinopathyStackedOptions.scales.yAxes[0].scaleLabel = {};
		$scope.meAndRetinopathyStackedOptions.scales.yAxes[0].scaleLabel.display = true;
		$scope.meAndRetinopathyStackedOptions.scales.yAxes[0].scaleLabel.labelString = "Cumulative incidence (%)";
		//$scope.meAndRetinopathyStackedOptions.scales.yAxes[0].ticks.max = 100;

		$scope.neuropathySeries = ["Amputation", "Neuropathy"];
		$scope.neuropathyCurve1 = $scope.proportions2DToPercentage([data.arms['1'].cumulativeIncidenceAmputationOverTime, data.arms['1'].cumulativeIncidenceNeuropathyOverTime]);
		$scope.neuropathyCurve2 = $scope.proportions2DToPercentage([data.arms['0'].cumulativeIncidenceAmputationOverTime, data.arms['0'].cumulativeIncidenceNeuropathyOverTime]);

		$scope.graftStatusProgressionsLabels1 = [];
		$scope.graftStatusProgressionSeries1 = [];
		$scope.graftStatusProgressionData1 = [];
		$scope.graftStatusProgressionOverride1 = [];

		if (data.arms['0'].graftStatusProgression !== undefined) {
			Object.keys(data.arms['0'].graftStatusProgression).forEach(function(o) {
				$scope.graftStatusProgressionsLabels1.push(o);
			});

			const graftStatusProgressions = new Set();
			Object.values(data.arms['0'].graftStatusProgression).forEach(function(o) {
				Object.keys(o).forEach(function(k) {
					graftStatusProgressions.add(k);
				})
			});

			$scope.graftStatusProgressionSeries1 = ["Insulin independent", "Partial graft function", "No graft function"];

			const graftStatusProgressionData = [];
			const graftStatusProgressionOverride = [];

			Array.from(graftStatusProgressions.values()).forEach(function(line, i) {
				const lineOverTime = [];
				Object.entries(data.arms['0'].graftStatusProgression).forEach(function(treatmentBreakdownInYear) {
					if (treatmentBreakdownInYear[1].hasOwnProperty(line)) {
						lineOverTime.push(treatmentBreakdownInYear[1][line] * 100);
					} else {
						lineOverTime.push(0);
					}
				})
				graftStatusProgressionData.push(lineOverTime);
				graftStatusProgressionOverride.push({
					borderWidth: 0,
					backgroundColor: $scope.complicationColors[i]
				});
			});

			$scope.graftStatusProgressionData1 = graftStatusProgressionData;
			$scope.graftStatusProgressionOverride1 = graftStatusProgressionOverride;
		}

		$scope.graftStatusProgressionsLabels2 = [];
		$scope.graftStatusProgressionSeries2 = [];
		$scope.graftStatusProgressionData2 = [];
		$scope.graftStatusProgressionOverride2 = [];

		let graftStatusProgressionData;
		let graftStatusProgressionOverride;
		if (data.arms['1'].graftStatusProgression !== undefined) {
			Object.keys(data.arms['1'].graftStatusProgression).forEach(function (o) {
				$scope.graftStatusProgressionsLabels2.push(o);
			});

			const graftStatusProgressions2 = new Set();
			Object.values(data.arms['1'].graftStatusProgression).forEach(function (o) {
				Object.keys(o).forEach(function (k) {
					graftStatusProgressions2.add(k);
				})
			});

			$scope.graftStatusProgressionSeries2 = ["Insulin independent", "Partial graft function", "No graft function"];

			graftStatusProgressionData = [];
			graftStatusProgressionOverride = [];

			Array.from(graftStatusProgressions2.values()).forEach(function (line, i) {
				const lineOverTime = [];
				Object.entries(data.arms['1'].graftStatusProgression).forEach(function (treatmentBreakdownInYear) {
					if (treatmentBreakdownInYear[1].hasOwnProperty(line)) {
						lineOverTime.push(treatmentBreakdownInYear[1][line] * 100);
					} else {
						lineOverTime.push(0);
					}
				})
				graftStatusProgressionData.push(lineOverTime);
				graftStatusProgressionOverride.push({
					borderWidth: 0,
					backgroundColor: $scope.complicationColors[i]
				});
			});

			$scope.graftStatusProgressionData2 = graftStatusProgressionData;
			$scope.graftStatusProgressionOverride2 = graftStatusProgressionOverride;
		}

		$scope.reInfusionsLinesLabels1 = [];
		$scope.reInfusionsLineSeries1 = [];
		$scope.reInfusionsLineData1 = [];
		$scope.reInfusionsLineOverride1 = [];

		if (data.arms['0'].reInfusionsProgression != undefined) {
			Object.keys(data.arms['0'].reInfusionsProgression).forEach(function(o) {
				$scope.reInfusionsLinesLabels1.push(o);
			});

			const reInfusionsLines = new Set();
			Object.values(data.arms['0'].reInfusionsProgression).forEach(function(o) {
				Object.keys(o).forEach(function(k) {
					reInfusionsLines.add(k);
				})
			});

			$scope.reInfusionsLineSeries1 = Array.from(reInfusionsLines.values());

			var reInfusionsLineData = [];
			var reInfusionsLineOverride = [];

			$scope.reInfusionsLineSeries1.forEach(function(line, i) {
				var lineOverTime = new Array();
				Object.entries(data.arms['0'].reInfusionsProgression).forEach(function(reInfusionsBreakdownInYear) {
					if (reInfusionsBreakdownInYear[1].hasOwnProperty(line)) {
						lineOverTime.push(reInfusionsBreakdownInYear[1][line] * 100);
					} else {
						lineOverTime.push(0);
					}
				})
				reInfusionsLineData.push(lineOverTime);
				reInfusionsLineOverride.push({
					borderWidth: 0,
					backgroundColor: $scope.complicationColors[i]
				});
			});

			$scope.reInfusionsLineData1 = reInfusionsLineData;
			$scope.reInfusionsLineOverride1 = reInfusionsLineOverride;
		}


		$scope.reInfusionsLinesLabels2 = [];
		$scope.reInfusionsLineSeries2 = [];
		$scope.reInfusionsLineData2 = [];
		$scope.reInfusionsLineOverride2 = [];

		if (data.arms['1'].reInfusionsProgression != undefined) {
			Object.keys(data.arms['1'].reInfusionsProgression).forEach(function(o) {
				$scope.reInfusionsLinesLabels2.push(o);
			});

			const reInfusionsLines2 = new Set();
			Object.values(data.arms['1'].reInfusionsProgression).forEach(function(o) {
				Object.keys(o).forEach(function(k) {
					reInfusionsLines2.add(k);
				})
			});

			$scope.reInfusionsLineSeries2 = Array.from(reInfusionsLines2.values());

			reInfusionsLineData = [];
			reInfusionsLineOverride = [];

			$scope.reInfusionsLineSeries2.forEach(function(line, i) {
				var lineOverTime = new Array();
				Object.entries(data.arms['1'].reInfusionsProgression).forEach(function(reInfusionsBreakdownInYear) {
					if (reInfusionsBreakdownInYear[1].hasOwnProperty(line)) {
						lineOverTime.push(reInfusionsBreakdownInYear[1][line] * 100);
					} else {
						lineOverTime.push(0);
					}
				})
				reInfusionsLineData.push(lineOverTime);
				reInfusionsLineOverride.push({
					borderWidth: 0,
					backgroundColor: $scope.complicationColors[i]
				});
			});

			$scope.reInfusionsLineData2 = reInfusionsLineData;
			$scope.reInfusionsLineOverride2 = reInfusionsLineOverride;
		}

		$scope.treatmentLinesLabels1 = [];
		$scope.treatmentLineSeries1 = [];
		$scope.treatmentLineData1 = [];
		$scope.treatmentLineOverride1 = [];

		if (data.arms['0'].treatmentProgression != undefined) {
			Object.keys(data.arms['0'].treatmentProgression).forEach(function(o) {
				$scope.treatmentLinesLabels1.push(o);
			});

			const treatmentLines = new Set();
			Object.values(data.arms['0'].treatmentProgression).forEach(function(o) {
				Object.keys(o).forEach(function(k) {
					treatmentLines.add(k);
				})
			});

			$scope.treatmentLineSeries1 = Array.from(treatmentLines.values());

			var treatmentLineData = [];
			var treatmentLineOverride = [];

			$scope.treatmentLineSeries1.forEach(function(line, i) {
				var lineOverTime = new Array();
				Object.entries(data.arms['0'].treatmentProgression).forEach(function(treatmentBreakdownInYear) {
					if (treatmentBreakdownInYear[1].hasOwnProperty(line)) {
						lineOverTime.push(treatmentBreakdownInYear[1][line] * 100);
					} else {
						lineOverTime.push(0);
					}
				})
				treatmentLineData.push(lineOverTime);
				treatmentLineOverride.push({
					borderWidth: 0,
					backgroundColor: $scope.complicationColors[i]
				});
			});

			$scope.treatmentLineData1 = treatmentLineData;
			$scope.treatmentLineOverride1 = treatmentLineOverride;
		}


		$scope.treatmentLinesLabels2 = [];
		$scope.treatmentLineSeries2 = [];
		$scope.treatmentLineData2 = [];
		$scope.treatmentLineOverride2 = [];

		if (data.arms['1'].treatmentProgression != undefined) {
			Object.keys(data.arms['1'].treatmentProgression).forEach(function(o) {
				$scope.treatmentLinesLabels2.push(o);
			});

			const treatmentLines2 = new Set();
			Object.values(data.arms['1'].treatmentProgression).forEach(function(o) {
				Object.keys(o).forEach(function(k) {
					treatmentLines2.add(k);
				})
			});

			$scope.treatmentLineSeries2 = Array.from(treatmentLines2.values());

			treatmentLineData = [];
			treatmentLineOverride = [];

			$scope.treatmentLineSeries2.forEach(function(line, i) {
				var lineOverTime = new Array();
				Object.entries(data.arms['1'].treatmentProgression).forEach(function(treatmentBreakdownInYear) {
					if (treatmentBreakdownInYear[1].hasOwnProperty(line)) {
						lineOverTime.push(treatmentBreakdownInYear[1][line] * 100);
					} else {
						lineOverTime.push(0);
					}
				})
				treatmentLineData.push(lineOverTime);
				treatmentLineOverride.push({
					borderWidth: 0,
					backgroundColor: $scope.complicationColors[i]
				});
			});

			$scope.treatmentLineData2 = treatmentLineData;
			$scope.treatmentLineOverride2 = treatmentLineOverride;
		}
		
		if (data.psa) {
			$scope.scatterOptions = {
				type: 'scatter',
				animation: false,
				tooltips: {
					callbacks: {
						title: function(tooltipItem, tooltipData) {
							return '';
						},
						label: function(tooltipItem, tooltipData) {
							return (tooltipItem.xLabel.toFixed(3) > 0 ? "+" : "") + tooltipItem.xLabel.toFixed(3) + " QALYs   " + 
							tooltipItem.yLabel.toFixed(2) + " " + data.fullElements.costs[0].currency;	
						}
					}
				},
				showLines : false,
				scales: {
					yAxes: [{
						scaleLabel: {
							display: true,
							labelString: 'Incremental cost' + (data.fullElements.costs[0].currency !== undefined ? " (" + data.fullElements.costs[0].currency + ")" : "")
						}
					}],
					xAxes: [{
						type: 'linear',
						position: 'bottom',
						scaleLabel: {
							display: true,
							labelString: 'Incremental quality-adjusted life expectancy (QALYs)'
						}
						/*ticks: {
							max:0
						}*/
					}]
				}
			}
			$scope.psa = [];
			$scope.psaDiffs = {};
			$scope.psaDiffs.qale = [];
			$scope.psaDiffs.cost = [];
			
			$scope.psaConfidenceIntervals = {};
			$scope.psaConfidenceIntervals.icerSum = 0;
			$scope.psaConfidenceIntervals.arm0 = {};
			$scope.psaConfidenceIntervals.arm0.qale95CILB = 0;
			$scope.psaConfidenceIntervals.arm0.qale95CIUB = 0;
			$scope.psaConfidenceIntervals.arm0.cost95CILB = 0;
			$scope.psaConfidenceIntervals.arm0.cost95CIUB = 0;
			
			$scope.psaConfidenceIntervals.arm1 = {};
			$scope.psaConfidenceIntervals.arm1.qale95CILB = 0;
			$scope.psaConfidenceIntervals.arm1.qale95CIUB = 0;
			$scope.psaConfidenceIntervals.arm1.cost95CILB = 0;
			$scope.psaConfidenceIntervals.arm1.cost95CIUB = 0;
			
			$scope.psaConfidenceIntervals.diff = {};
			$scope.psaConfidenceIntervals.diff.qale95CILB = 0;
			$scope.psaConfidenceIntervals.diff.qale95CIUB = 0;
			$scope.psaConfidenceIntervals.diff.cost95CILB = 0;
			$scope.psaConfidenceIntervals.diff.cost95CIUB = 0;
			
			for (var i = 0; i < data.arms['0'].psaResults.cost.length; i++) {
				$scope.psa.push({
					x: (data.arms['1'].psaResults.qale[i] - data.arms['0'].psaResults.qale[i]),
					y: (data.arms['1'].psaResults.cost[i] - data.arms['0'].psaResults.cost[i]) / (Math.min(2000, Math.round(data.patients / 10)))
				});
				$scope.psaDiffs.qale.push(data.arms['1'].psaResults.qale[i] - data.arms['0'].psaResults.qale[i]);
				$scope.psaDiffs.cost.push((data.arms['1'].psaResults.cost[i] - data.arms['0'].psaResults.cost[i]) / (Math.min(2000, Math.round(data.patients / 10))));
			}
			
			$scope.psaConfidenceIntervals.arm0.qale95CILB = Stats.mean(data.arms['0'].psaResults.qale) - Stats.sd(data.arms['0'].psaResults.qale);
			$scope.psaConfidenceIntervals.arm0.qale95CIUB = Stats.mean(data.arms['0'].psaResults.qale) + Stats.sd(data.arms['0'].psaResults.qale);
			
			$scope.psaConfidenceIntervals.arm0.cost95CILB = (Stats.mean(data.arms['0'].psaResults.cost) - Stats.sd(data.arms['0'].psaResults.cost)) / Math.min(2000, Math.round(data.patients / 10));
			$scope.psaConfidenceIntervals.arm0.cost95CIUB = (Stats.mean(data.arms['0'].psaResults.cost) + Stats.sd(data.arms['0'].psaResults.cost)) / Math.min(2000, Math.round(data.patients / 10));
			
			$scope.psaConfidenceIntervals.arm1.qale95CILB = Stats.mean(data.arms['1'].psaResults.qale) - Stats.sd(data.arms['1'].psaResults.qale);
			$scope.psaConfidenceIntervals.arm1.qale95CIUB = Stats.mean(data.arms['1'].psaResults.qale) + Stats.sd(data.arms['1'].psaResults.qale);
			
			$scope.psaConfidenceIntervals.arm1.cost95CILB = (Stats.mean(data.arms['1'].psaResults.cost) - Stats.sd(data.arms['1'].psaResults.cost)) / Math.min(2000, Math.round(data.patients / 10));
			$scope.psaConfidenceIntervals.arm1.cost95CIUB = (Stats.mean(data.arms['1'].psaResults.cost) + Stats.sd(data.arms['1'].psaResults.cost)) / Math.min(2000, Math.round(data.patients / 10));
			
			$scope.psaConfidenceIntervals.diff.qale95CILB = Stats.mean($scope.psaDiffs.qale) - Stats.sd($scope.psaDiffs.qale);
			$scope.psaConfidenceIntervals.diff.qale95CIUB = Stats.mean($scope.psaDiffs.qale) + Stats.sd($scope.psaDiffs.qale);
			
			$scope.psaConfidenceIntervals.diff.cost95CILB = (Stats.mean($scope.psaDiffs.cost) - Stats.sd($scope.psaDiffs.cost));
			$scope.psaConfidenceIntervals.diff.cost95CIUB = (Stats.mean($scope.psaDiffs.cost) + Stats.sd($scope.psaDiffs.cost));
			
			$scope.maxWTP = 10000;
			
			($scope.recalcCEAC = function() {
				$scope.ceac = [];
				$scope.ceacLabels = [];
				for (var i = 0; i <= 100; i++) {
					var wtp = i * ($scope.maxWTP/100);
					$scope.ceac.push($scope.psa.reduce(function(acc, val, i, arr) {
						if (val.x > 0 && val.y < 0) { // SE quadrant - count all
							++acc;
						}
						if (val.x > 0 && val.y > 0 && val.y/val.x < wtp) { // NE quadrant - count < WTP
							++acc;
						}
						if (val.x < 0 && val.y < 0 && val.y/val.x > wtp) { // SW quadrant - count > WTP
							++acc
						}
						return acc;
					}, 0)/$scope.psa.length * 100);
					$scope.ceacLabels.push(wtp);
				};
			})();
			$scope.ceacOptions = angular.copy($scope.options);
			$scope.ceacOptions.scales.xAxes[0].scaleLabel.labelString = "Willingness-to-pay threshold" + (data.fullElements.costs[0].currency !== undefined ? " (" + data.fullElements.costs[0].currency + " per QALY gained)" : "");
			$scope.ceacOptions.scales.yAxes[0].scaleLabel = {};
			$scope.ceacOptions.scales.yAxes[0].scaleLabel.labelString = "Likelihood of intervention being cost-effective (%)";
			$scope.ceacOptions.scales.yAxes[0].scaleLabel.display = true;
			$scope.ceacOptions.scales.yAxes[0].ticks.max = 100;
			$scope.ceacOptions.legend.display = false;
			$scope.ceacOptions.aspectRatio = 1.8;
			$scope.ceacOptions.tooltips.callbacks.label = function(tooltipItem, data) {
				return tooltipItem.yLabel.toFixed(1) + "%";
			}
		}
	});

}]);

PRIMEControllers.controller("ExportT1D", ["$scope", "$http", "$interval", "$window", "$modalInstance", "jobId", function ($scope, $http, $interval, $window, $modalInstance, jobId) {
  $scope.jobId = jobId;
  $scope.loading = true;
  $scope.result = null;

  var tick = function() {
    $http.get('/api/t1d/simulations/batchexport/' + jobId).then(function(res) {
      if (res.data.status === 'COMPLETED') {
        $scope.loading = false;
        $scope.result = res.data;
        $interval.cancel(pollInterval);
        if ($scope.result.downloadUrl) {
          $window.open($scope.result.downloadUrl, '_blank');
        }
        $modalInstance.close();
      }
    }, function(err) {
      console.error("Polling failed", err);
    });
  };

  var pollInterval = $interval(tick, 5000);
  tick();

  $scope.$on('$destroy', function() {
    $interval.cancel(pollInterval);
  });
}]);

PRIMEControllers.controller("NewSimulation", ["$scope", "$rootScope", "$routeParams", "$location", "SimulationService", function ($scope, $rootScope, $routeParams, $location, SimulationService) {
	$scope.strings = {
		"title":"New Simulation"
	}
	
	if ($routeParams.id !== undefined) {
		$scope.simulation = SimulationService.clone({simulationId:$routeParams.id});
		$scope.simulation.$promise.then(function(simulation) {
			delete simulation._id;
			simulation.name = simulation.name + " copy";
			simulation.sharedWith = [];
			simulation.creationDate = new Date().getTime();
			if (simulation.randomSeed === undefined) simulation.randomSeed = 31415;
		})

	} else {
		$scope.simulation = {
			name: "Simulation",
			patients: 300000,
			timeHorizon: 50,
			randomSeed: 31415,
			notes : "",
			creationDate: new Date().getTime(),
			baselineCovariance: false,
			progressionCovariance: false,
			psa: false,
			elements: {cohortIDs:[],
				treatmentIDs:[],
				costIDs:[],
				utilityIDs:[],
				countryIDs:[]
			},
			arms: {}
		};
	}

	
	$scope.runSimulation = function() {
		$scope.simulation["progress"] = "Waiting";
		
		SimulationService.save($scope.simulation, function() { });
		
		$location.path("/simulations/")
	}
}]);






PRIMEControllers.controller("Debug", ["$route", "$routeParams", "$location", "$scope", "$rootScope",
	function($route, $routeParams, $location, $scope, $rootScope) {
		this.$route = $route;
		this.$location = $location;
		this.$routeParams = $routeParams;
		
		this.apiAccessibility = "UP";
		this.apiURL = $rootScope.apiConfig[0];
		this.jQueryOrigin = window.jQueryOrigin;
		
		$scope.debugger = false;
		
		var unregisterKeypress = $scope.$on("keypress:4", function(ngEvent, domEvent) {
			if (domEvent.ctrlKey && domEvent.shiftKey) {
				ngEvent.currentScope.debugger = !ngEvent.currentScope.debugger;
				ngEvent.currentScope.$apply();	
			}
		});
		
		$scope.$on("$destroy", unregisterKeypress);
	}
])
